// theme/ts/base.ts
var base_default = {
  primitive: {
    red: {
      50: "#fdf5f5",
      100: "#f4cfd0",
      200: "#eca9ab",
      300: "#e38386",
      400: "#db5d61",
      500: "#d2373c",
      600: "#b32f33",
      700: "#93272a",
      800: "#741e21",
      900: "#541618",
      950: "#350e0f"
    },
    sky: {
      50: "#f3f8fd",
      100: "#c5def5",
      200: "#97c3ed",
      300: "#68a9e4",
      400: "#3a8edc",
      500: "#0c74d4",
      600: "#0a63b4",
      700: "#085194",
      800: "#074075",
      900: "#052e55",
      950: "#031d35"
    },
    blue: {
      50: "#eff6ff",
      100: "#dbeafe",
      200: "#bfdbfe",
      300: "#93c5fd",
      400: "#60a5fa",
      500: "#3b82f6",
      600: "#2563eb",
      700: "#1d4ed8",
      800: "#1e40af",
      900: "#1e3a8a",
      950: "#172554"
    },
    cyan: {
      50: "#ecfeff",
      100: "#cffafe",
      200: "#a5f3fc",
      300: "#67e8f9",
      400: "#22d3ee",
      500: "#06b6d4",
      600: "#0891b2",
      700: "#0e7490",
      800: "#155e75",
      900: "#164e63",
      950: "#083344"
    },
    gray: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827",
      950: "#030712"
    },
    lime: {
      50: "#f7fee7",
      100: "#ecfccb",
      200: "#d9f99d",
      300: "#bef264",
      400: "#a3e635",
      500: "#84cc16",
      600: "#65a30d",
      700: "#4d7c0f",
      800: "#3f6212",
      900: "#365314",
      950: "#1a2e05"
    },
    pink: {
      50: "#fdf2f8",
      100: "#fce7f3",
      200: "#fbcfe8",
      300: "#f9a8d4",
      400: "#f472b6",
      500: "#ec4899",
      600: "#db2777",
      700: "#be185d",
      800: "#9d174d",
      900: "#831843",
      950: "#500724"
    },
    rose: {
      50: "#fff1f2",
      100: "#ffe4e6",
      200: "#fecdd3",
      300: "#fda4af",
      400: "#fb7185",
      500: "#f43f5e",
      600: "#e11d48",
      700: "#be123c",
      800: "#9f1239",
      900: "#881337",
      950: "#4c0519"
    },
    teal: {
      50: "#f0fdfa",
      100: "#ccfbf1",
      200: "#99f6e4",
      300: "#5eead4",
      400: "#2dd4bf",
      500: "#14b8a6",
      600: "#0d9488",
      700: "#0f766e",
      800: "#115e59",
      900: "#134e4a",
      950: "#042f2e"
    },
    zinc: {
      50: "#fafafa",
      100: "#f4f4f5",
      200: "#e4e4e7",
      300: "#d4d4d8",
      400: "#a1a1aa",
      500: "#71717a",
      600: "#52525b",
      700: "#3f3f46",
      800: "#27272a",
      900: "#18181b",
      950: "#09090b"
    },
    amber: {
      50: "#fffbf6",
      100: "#ffecd5",
      200: "#ffdcb5",
      300: "#ffcd94",
      400: "#ffbd73",
      500: "#ffae52",
      600: "#d99446",
      700: "#b37a39",
      800: "#8c602d",
      900: "#664621",
      950: "#402c15"
    },
    green: {
      50: "#f2f8f5",
      100: "#c2dfcf",
      200: "#91c6a9",
      300: "#61ad83",
      400: "#30935d",
      500: "#007a37",
      600: "#00682f",
      700: "#005527",
      800: "#00431e",
      900: "#003116",
      950: "#001f0e"
    },
    slate: {
      50: "#f8fafc",
      100: "#f1f5f9",
      200: "#e2e8f0",
      300: "#cbd5e1",
      400: "#94a3b8",
      500: "#64748b",
      600: "#475569",
      700: "#334155",
      800: "#1e293b",
      900: "#0f172a",
      950: "#020617"
    },
    stone: {
      50: "#fafaf9",
      100: "#f5f5f4",
      200: "#e7e5e4",
      300: "#d6d3d1",
      400: "#a8a29e",
      500: "#78716c",
      600: "#57534e",
      700: "#44403c",
      800: "#292524",
      900: "#1c1917",
      950: "#0c0a09"
    },
    indigo: {
      50: "#f5f3fa",
      100: "#cdc6e8",
      200: "#a598d5",
      300: "#7d6bc3",
      400: "#563db0",
      500: "#2e109e",
      600: "#270e86",
      700: "#200b6f",
      800: "#190957",
      900: "#12063f",
      950: "#0c0428"
    },
    orange: {
      50: "#fff9f3",
      100: "#ffe4c4",
      200: "#ffce96",
      300: "#ffb867",
      400: "#ffa339",
      500: "#ff8d0a",
      600: "#d97809",
      700: "#b36307",
      800: "#8c4e06",
      900: "#663804",
      950: "#402303"
    },
    purple: {
      50: "#fbf7ff",
      100: "#ecd7ff",
      200: "#dcb7ff",
      300: "#cd97ff",
      400: "#bd77ff",
      500: "#ae57ff",
      600: "#944ad9",
      700: "#7a3db3",
      800: "#60308c",
      900: "#462366",
      950: "#2c1640"
    },
    violet: {
      50: "#f5f3ff",
      100: "#ede9fe",
      200: "#ddd6fe",
      300: "#c4b5fd",
      400: "#a78bfa",
      500: "#8b5cf6",
      600: "#7c3aed",
      700: "#6d28d9",
      800: "#5b21b6",
      900: "#4c1d95",
      950: "#2e1065"
    },
    yellow: {
      50: "#fefce8",
      100: "#fef9c3",
      200: "#fef08a",
      300: "#fde047",
      400: "#facc15",
      500: "#eab308",
      600: "#ca8a04",
      700: "#a16207",
      800: "#854d0e",
      900: "#713f12",
      950: "#422006"
    },
    emerald: {
      50: "#ecfdf5",
      100: "#d1fae5",
      200: "#a7f3d0",
      300: "#6ee7b7",
      400: "#34d399",
      500: "#10b981",
      600: "#059669",
      700: "#047857",
      800: "#065f46",
      900: "#064e3b",
      950: "#022c22"
    },
    fuchsia: {
      50: "#fdf4ff",
      100: "#fae8ff",
      200: "#f5d0fe",
      300: "#f0abfc",
      400: "#e879f9",
      500: "#d946ef",
      600: "#c026d3",
      700: "#a21caf",
      800: "#86198f",
      900: "#701a75",
      950: "#4a044e"
    },
    neutral: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#e5e5e5",
      300: "#d4d4d4",
      400: "#a3a3a3",
      500: "#737373",
      600: "#525252",
      700: "#404040",
      800: "#262626",
      900: "#171717",
      950: "#0a0a0a"
    },
    borderRadius: {
      lg: "16px",
      md: "12px",
      sm: "8px",
      xl: "24px",
      xs: "4px",
      none: "0"
    }
  },
  semantic: {
    list: {
      gap: "0",
      header: {
        padding: "0.625rem 1rem 0 1rem"
      },
      option: {
        padding: "0.625rem 1rem",
        borderRadius: "0",
        icon: {
          color: "light-dark({surface.400}, {surface.500})",
          focusColor: "light-dark({surface.500}, {surface.400})"
        },
        color: "{text.color}",
        focusColor: "{text.hover.color}",
        selectedColor: "{highlight.color}",
        focusBackground: "light-dark({surface.100}, {surface.800})",
        selectedBackground: "{highlight.background}",
        selectedFocusColor: "{highlight.focus.color}",
        selectedFocusBackground: "{highlight.focus.background}"
      },
      padding: "0.5rem 0",
      optionGroup: {
        padding: "0.625rem 1rem",
        fontWeight: "600",
        color: "{text.color}",
        background: "transparent"
      }
    },
    mask: {
      transitionDuration: "0.3s",
      color: "{surface.200}",
      background: "light-dark(rgba(0,0,0,0.4), rgba(0,0,0,0.6))"
    },
    content: {
      borderRadius: "{border.radius.md}",
      color: "{text.color}",
      background: "light-dark({surface.0}, {surface.900})",
      hoverColor: "{text.hover.color}",
      borderColor: "light-dark({surface.200}, {surface.700})",
      hoverBackground: "light-dark({surface.100}, {surface.800})"
    },
    overlay: {
      modal: {
        shadow: "0 1px 3px rgba(0, 0, 0, 0.3)",
        padding: "1.5rem",
        borderRadius: "{border.radius.xl}",
        color: "{text.color}",
        background: "light-dark({surface.0}, {surface.900})",
        borderColor: "light-dark({surface.200}, {surface.700})"
      },
      select: {
        shadow: "0 2px 12px 0 rgba(0, 0, 0, 0.1)",
        borderRadius: "{border.radius.md}",
        color: "{text.color}",
        background: "light-dark({surface.0}, {surface.900})",
        borderColor: "light-dark({surface.200}, {surface.700})"
      },
      popover: {
        shadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        padding: "1rem",
        borderRadius: "{border.radius.md}",
        color: "{text.color}",
        background: "light-dark({surface.0}, {surface.900})",
        borderColor: "light-dark({surface.200}, {surface.700})"
      },
      navigation: {
        shadow: "0 2px 12px 0 rgba(0, 0, 0, 0.1)"
      }
    },
    primary: {
      50: "{indigo.50}",
      100: "{indigo.100}",
      200: "{indigo.200}",
      300: "{indigo.300}",
      400: "{indigo.400}",
      500: "{indigo.500}",
      600: "{indigo.600}",
      700: "{indigo.700}",
      800: "{indigo.800}",
      900: "{indigo.900}",
      950: "{indigo.950}",
      color: "light-dark({primary.500}, {primary.400})",
      hoverColor: "light-dark({primary.400}, {primary.300})",
      activeColor: "light-dark({primary.800}, {primary.200})",
      contrastColor: "light-dark(#ffffff, {surface.900})"
    },
    iconSize: "1rem",
    focusRing: {
      color: "transparent",
      style: "none",
      width: "0",
      offset: "0",
      shadow: "light-dark(0 0 0 0.2rem {primary.200}, 0 0 0 0.2rem color-mix(in srgb, {primary.color}, transparent 80%))"
    },
    formField: {
      lg: {
        fontSize: "1.125rem",
        paddingX: "0.875rem",
        paddingY: "0.84375rem"
      },
      sm: {
        fontSize: "0.875rem",
        paddingX: "0.625rem",
        paddingY: "0.53125rem"
      },
      paddingX: "0.75rem",
      paddingY: "0.6875rem",
      focusRing: {
        color: "{focus.ring.color}",
        style: "{focus.ring.style}",
        width: "{focus.ring.width}",
        offset: "{focus.ring.offset}",
        shadow: "{focus.ring.shadow}"
      },
      borderRadius: "{border.radius.md}",
      transitionDuration: "{transition.duration}",
      color: "light-dark({surface.700}, {surface.0})",
      shadow: "none",
      iconColor: "light-dark({surface.500}, {surface.400})",
      background: "light-dark({surface.0}, {surface.950})",
      borderColor: "light-dark({surface.400}, {surface.600})",
      disabledColor: "light-dark({surface.500}, {surface.400})",
      floatLabelColor: "light-dark({surface.500}, {surface.400})",
      filledBackground: "light-dark({surface.50}, {surface.800})",
      focusBorderColor: "{primary.color}",
      hoverBorderColor: "{primary.color}",
      placeholderColor: "light-dark({surface.400}, {surface.400})",
      disabledBackground: "light-dark({surface.200}, {surface.700})",
      invalidBorderColor: "light-dark({red.400}, {red.300})",
      floatLabelFocusColor: "light-dark({primary.600}, {primary.color})",
      filledFocusBackground: "light-dark({surface.0}, {surface.950})",
      filledHoverBackground: "light-dark({surface.50}, {surface.800})",
      floatLabelActiveColor: "light-dark({surface.500}, {surface.400})",
      floatLabelInvalidColor: "{form.field.invalid.placeholder.color}",
      invalidPlaceholderColor: "light-dark({red.600}, {red.400})"
    },
    navigation: {
      item: {
        gap: "0.5rem",
        padding: "0.625rem 1rem",
        borderRadius: "0",
        icon: {
          color: "light-dark({surface.400}, {surface.500})",
          focusColor: "light-dark({surface.500}, {surface.400})",
          activeColor: "light-dark({surface.500}, {surface.400})"
        },
        color: "{text.color}",
        focusColor: "{text.hover.color}",
        activeColor: "{text.hover.color}",
        focusBackground: "light-dark({surface.100}, {surface.800})",
        activeBackground: "light-dark({surface.100}, {surface.800})"
      },
      list: {
        gap: "0",
        padding: "0.5rem 0"
      },
      submenuIcon: {
        size: "0.875rem",
        color: "light-dark({surface.400}, {surface.500})",
        focusColor: "light-dark({surface.500}, {surface.400})",
        activeColor: "light-dark({surface.500}, {surface.400})"
      },
      submenuLabel: {
        padding: "0.625rem 1rem",
        fontWeight: "600",
        color: "{text.color}",
        background: "transparent"
      }
    },
    anchorGutter: "2px",
    disabledOpacity: "0.6",
    transitionDuration: "0.1s",
    text: {
      color: "light-dark({surface.700}, {surface.0})",
      hoverColor: "light-dark({surface.800}, {surface.0})",
      mutedColor: "light-dark({surface.500}, {surface.400})",
      hoverMutedColor: "light-dark({surface.600}, {surface.300})"
    },
    surface: {
      0: "#ffffff",
      50: "light-dark({slate.50}, {zinc.50})",
      100: "light-dark({slate.100}, {zinc.100})",
      200: "light-dark({slate.200}, {zinc.200})",
      300: "light-dark({slate.300}, {zinc.300})",
      400: "light-dark({slate.400}, {zinc.400})",
      500: "light-dark({slate.500}, {zinc.500})",
      600: "light-dark({slate.600}, {zinc.600})",
      700: "light-dark({slate.700}, {zinc.700})",
      800: "light-dark({slate.800}, {zinc.800})",
      900: "light-dark({slate.900}, {zinc.900})",
      950: "light-dark({slate.950}, {zinc.950})"
    },
    highlight: {
      color: "light-dark({primary.700}, rgba(255,255,255,.87))",
      background: "light-dark({primary.50}, color-mix(in srgb, {primary.400}, transparent 84%))",
      focusColor: "light-dark({primary.800}, rgba(255,255,255,.87))",
      focusBackground: "light-dark({primary.100}, color-mix(in srgb, {primary.400}, transparent 76%))"
    }
  }
};

// theme/ts/tag.ts
var tag_default = {
  icon: {
    size: "0.75rem"
  },
  root: {
    gap: "0.25rem",
    padding: "0.25rem 0.5rem",
    fontSize: "0.875rem",
    fontWeight: "700",
    borderRadius: "{content.border.radius}",
    roundedBorderRadius: "{border.radius.xl}"
  },
  info: {
    color: "light-dark({surface.0}, {sky.950})",
    background: "light-dark({sky.500}, {sky.400})"
  },
  warn: {
    color: "light-dark({surface.0}, {orange.950})",
    background: "light-dark({orange.500}, {orange.400})"
  },
  danger: {
    color: "light-dark({surface.0}, {red.950})",
    background: "light-dark({red.500}, {red.400})"
  },
  primary: {
    color: "{primary.contrast.color}",
    background: "{primary.color}"
  },
  success: {
    color: "light-dark({surface.0}, {green.950})",
    background: "light-dark({green.500}, {green.400})"
  },
  contrast: {
    color: "light-dark({surface.0}, {surface.950})",
    background: "light-dark({surface.950}, {surface.0})"
  },
  secondary: {
    color: "light-dark({primary.600}, {surface.300})",
    background: "light-dark({amber.400}, {surface.800})"
  }
};

// theme/ts/card.ts
var card_default = {
  body: {
    gap: "0.75rem",
    padding: "1.5rem"
  },
  root: {
    color: "{content.color}",
    shadow: "none",
    background: "{content.background}",
    borderRadius: "{border.radius.lg}"
  },
  title: {
    fontSize: "1.25rem",
    fontWeight: "700"
  },
  caption: {
    gap: "0.5rem"
  },
  subtitle: {
    color: "{text.muted.color}"
  }
};

// theme/ts/chip.ts
var chip_default = {
  icon: {
    size: "1rem",
    color: "light-dark({surface.800}, {surface.0})"
  },
  root: {
    gap: "0.5rem",
    paddingX: "0.875rem",
    paddingY: "0.625rem",
    borderRadius: "16px",
    transitionDuration: "{transition.duration}",
    color: "light-dark({surface.800}, {surface.0})",
    background: "light-dark({surface.100}, {surface.800})"
  },
  image: {
    width: "2rem",
    height: "2rem"
  },
  removeIcon: {
    size: "1rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    color: "light-dark({surface.800}, {surface.0})"
  }
};

// theme/ts/dock.ts
var dock_default = {
  item: {
    size: "3rem",
    padding: "0.5rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    borderRadius: "{content.border.radius}"
  },
  root: {
    padding: "0.5rem",
    background: "rgba(255, 255, 255, 0.1)",
    borderColor: "rgba(255, 255, 255, 0.2)",
    borderRadius: "{border.radius.lg}"
  }
};

// theme/ts/knob.ts
var knob_default = {
  root: {
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    transitionDuration: "{transition.duration}"
  },
  text: {
    color: "{text.muted.color}"
  },
  range: {
    background: "{content.border.color}"
  },
  value: {
    background: "{primary.color}"
  }
};

// theme/ts/menu.ts
var menu_default = {
  item: {
    gap: "{navigation.item.gap}",
    icon: {
      color: "{navigation.item.icon.color}",
      focusColor: "{navigation.item.icon.focus.color}"
    },
    color: "{navigation.item.color}",
    padding: "{navigation.item.padding}",
    focusColor: "{navigation.item.focus.color}",
    borderRadius: "{navigation.item.border.radius}",
    focusBackground: "{navigation.item.focus.background}"
  },
  list: {
    gap: "{navigation.list.gap}",
    padding: "{navigation.list.padding}"
  },
  root: {
    color: "{content.color}",
    shadow: "{overlay.navigation.shadow}",
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    transitionDuration: "{transition.duration}"
  },
  separator: {
    borderColor: "{content.border.color}"
  },
  submenuLabel: {
    color: "{navigation.submenu.label.color}",
    padding: "{navigation.submenu.label.padding}",
    background: "{navigation.submenu.label.background}",
    fontWeight: "{navigation.submenu.label.font.weight}"
  }
};

// theme/ts/tabs.ts
var tabs_default = {
  tab: {
    gap: "0.5rem",
    color: "{text.muted.color}",
    margin: "0",
    padding: "1rem 1.25rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "inset {focus.ring.shadow}"
    },
    fontWeight: "700",
    hoverColor: "{text.color}",
    activeColor: "{primary.color}",
    borderColor: "transparent",
    borderWidth: "0 0 2px 0",
    hoverBorderColor: "transparent",
    activeBorderColor: "{primary.color}",
    background: "light-dark({surface.50}, {surface.800})",
    hoverBackground: "light-dark({surface.100}, {surface.700})",
    activeBackground: "light-dark({surface.0}, {surface.900})"
  },
  root: {
    transitionDuration: "{transition.duration}"
  },
  tablist: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderWidth: "0"
  },
  tabpanel: {
    color: "{content.color}",
    padding: "0.875rem 1.125rem 1.125rem 1.125rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "inset {focus.ring.shadow}"
    },
    background: "{content.background}"
  },
  activeBar: {
    bottom: "0",
    height: "0",
    background: "transparent"
  },
  navButton: {
    color: "{text.muted.color}",
    width: "2.5rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "inset {focus.ring.shadow}"
    },
    background: "{content.background}",
    hoverColor: "{text.color}",
    shadow: "light-dark(0px 0px 10px 50px rgba(255, 255, 255, 0.6), 0px 0px 10px 50px color-mix(in srgb, {content.background}, transparent 50%))"
  }
};

// theme/ts/tree.ts
var tree_default = {
  node: {
    gap: "0.25rem",
    color: "{text.color}",
    padding: "0.375rem 0.625rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "inset {focus.ring.shadow}"
    },
    hoverColor: "{text.hover.color}",
    borderRadius: "{content.border.radius}",
    selectedColor: "{highlight.color}",
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{highlight.background}"
  },
  root: {
    gap: "2px",
    color: "{content.color}",
    indent: "1rem",
    padding: "1rem",
    background: "{content.background}",
    transitionDuration: "{transition.duration}"
  },
  filter: {
    margin: "0 0 0.5rem 0"
  },
  nodeIcon: {
    color: "{text.muted.color}",
    hoverColor: "{text.hover.muted.color}",
    selectedColor: "{highlight.color}"
  },
  loadingIcon: {
    size: "2rem"
  },
  nodeToggleButton: {
    size: "1.75rem",
    color: "{text.muted.color}",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    hoverColor: "{text.hover.muted.color}",
    borderRadius: "50%",
    hoverBackground: "{content.hover.background}",
    selectedHoverColor: "{primary.color}",
    selectedHoverBackground: "{content.background}"
  }
};

// theme/ts/badge.ts
var badge_default = {
  lg: {
    height: "1.75rem",
    fontSize: "0.875rem",
    minWidth: "1.75rem"
  },
  sm: {
    height: "1.25rem",
    fontSize: "0.625rem",
    minWidth: "1.25rem"
  },
  xl: {
    height: "2rem",
    fontSize: "1rem",
    minWidth: "2rem"
  },
  dot: {
    size: "0.5rem"
  },
  root: {
    height: "1.5rem",
    padding: "0 0.5rem",
    fontSize: "0.75rem",
    minWidth: "1.5rem",
    fontWeight: "700",
    borderRadius: "{border.radius.md}"
  },
  info: {
    color: "light-dark({surface.0}, {sky.950})",
    background: "light-dark({sky.500}, {sky.400})"
  },
  warn: {
    color: "light-dark({surface.0}, {orange.950})",
    background: "light-dark({orange.500}, {orange.400})"
  },
  danger: {
    color: "light-dark({surface.0}, {red.950})",
    background: "light-dark({red.500}, {red.400})"
  },
  primary: {
    color: "{primary.contrast.color}",
    background: "{primary.color}"
  },
  success: {
    color: "light-dark({surface.0}, {green.950})",
    background: "light-dark({green.500}, {green.400})"
  },
  contrast: {
    color: "light-dark({surface.0}, {surface.950})",
    background: "light-dark({surface.950}, {surface.0})"
  },
  secondary: {
    color: "light-dark({surface.600}, {surface.300})",
    background: "light-dark({surface.100}, {surface.800})"
  }
};

// theme/ts/image.ts
var image_default = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  action: {
    size: "3rem",
    color: "{surface.50}",
    iconSize: "1.5rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    hoverColor: "{surface.0}",
    borderRadius: "{content.border.radius}",
    hoverBackground: "rgba(255,255,255,0.1)"
  },
  preview: {
    icon: {
      size: "1.5rem"
    },
    mask: {
      color: "{mask.color}",
      background: "{mask.background}"
    }
  },
  toolbar: {
    gap: "0.5rem",
    blur: "8px",
    padding: ".5rem",
    position: {
      top: "1rem",
      left: "auto",
      right: "1rem",
      bottom: "auto"
    },
    background: "rgba(255,255,255,0.1)",
    borderColor: "rgba(255,255,255,0.2)",
    borderWidth: "1px",
    borderRadius: "{content.border.radius}"
  }
};

// theme/ts/panel.ts
var panel_default = {
  root: {
    color: "{content.color}",
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}"
  },
  title: {
    fontWeight: "700"
  },
  footer: {
    padding: "1rem"
  },
  header: {
    padding: "0.5rem 0.5rem 0.5rem 1rem ",
    borderColor: "{content.border.color}",
    borderWidth: "0 0 1px 0",
    borderRadius: "12px 12px 0 0",
    color: "{text.color}",
    background: "light-dark({surface.50}, {surface.800})"
  },
  content: {
    padding: "1em"
  },
  toggleableHeader: {
    padding: "0.25rem 1.125rem"
  }
};

// theme/ts/steps.ts
var steps_default = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  itemLink: {
    gap: "0.5rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    borderRadius: "{content.border.radius}"
  },
  itemLabel: {
    color: "{text.muted.color}",
    fontWeight: "500",
    activeColor: "{primary.color}"
  },
  separator: {
    background: "{content.border.color}"
  },
  itemNumber: {
    size: "2.25rem",
    color: "{text.muted.color}",
    shadow: "none",
    fontSize: "1.125rem",
    background: "{content.background}",
    fontWeight: "500",
    activeColor: "{primary.contrast.color}",
    borderColor: "{content.border.color}",
    borderRadius: "50%",
    activeBackground: "{primary.color}",
    activeBorderColor: "{primary.color}"
  }
};

// theme/ts/toast.ts
var toast_default = {
  icon: {
    size: "1.25rem"
  },
  root: {
    width: "25rem",
    borderWidth: "0 0 0 6px",
    borderRadius: "0",
    transitionDuration: "{transition.duration}",
    blur: "light-dark(1.5px, 10px)"
  },
  text: {
    gap: "0.5rem"
  },
  detail: {
    fontSize: "0.875rem",
    fontWeight: "500"
  },
  content: {
    gap: "0.5rem",
    padding: "{overlay.popover.padding}"
  },
  summary: {
    fontSize: "1rem",
    fontWeight: "500"
  },
  closeIcon: {
    size: "1rem"
  },
  closeButton: {
    width: "2rem",
    height: "2rem",
    focusRing: {
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}"
    },
    borderRadius: "50%"
  },
  info: {
    color: "light-dark({blue.600}, {blue.500})",
    shadow: "{overlay.popover.shadow}",
    background: "light-dark(color-mix(in srgb, {blue.50}, transparent 5%), color-mix(in srgb, {blue.500}, transparent 84%))",
    borderColor: "light-dark({blue.500}, color-mix(in srgb, {blue.700}, transparent 64%))",
    closeButton: {
      focusRing: {
        color: "{focus.ring.color}",
        shadow: "light-dark(0 0 0 0.2rem {blue.200}, 0 0 0 0.2rem color-mix(in srgb, {blue.500}, transparent 80%))"
      },
      hoverBackground: "light-dark({blue.100}, rgba(255, 255, 255, 0.05))"
    },
    detailColor: "light-dark({surface.700}, {surface.0})"
  },
  warn: {
    color: "light-dark({yellow.600}, {yellow.500})",
    shadow: "{overlay.popover.shadow}",
    background: "light-dark(color-mix(in srgb,{yellow.50}, transparent 5%), color-mix(in srgb, {yellow.500}, transparent 84%))",
    borderColor: "light-dark({yellow.500}, color-mix(in srgb, {yellow.700}, transparent 64%))",
    closeButton: {
      focusRing: {
        color: "{focus.ring.color}",
        shadow: "light-dark(0 0 0 0.2rem {yellow.200}, 0 0 0 0.2rem color-mix(in srgb, {yellow.500}, transparent 80%))"
      },
      hoverBackground: "light-dark({yellow.100}, rgba(255, 255, 255, 0.05))"
    },
    detailColor: "light-dark({surface.700}, {surface.0})"
  },
  error: {
    color: "light-dark({red.600}, {red.500})",
    shadow: "{overlay.popover.shadow}",
    background: "light-dark(color-mix(in srgb, {red.50}, transparent 5%), color-mix(in srgb, {red.500}, transparent 84%))",
    borderColor: "light-dark({red.500}, color-mix(in srgb, {red.700}, transparent 64%))",
    closeButton: {
      focusRing: {
        color: "{focus.ring.color}",
        shadow: "light-dark(0 0 0 0.2rem {red.200}, 0 0 0 0.2rem color-mix(in srgb, {red.500}, transparent 80%))"
      },
      hoverBackground: "light-dark({red.100}, rgba(255, 255, 255, 0.05))"
    },
    detailColor: "light-dark({surface.700}, {surface.0})"
  },
  success: {
    color: "light-dark({green.600}, {green.500})",
    shadow: "{overlay.popover.shadow}",
    background: "light-dark(color-mix(in srgb, {green.50}, transparent 5%), color-mix(in srgb, {green.500}, transparent 84%))",
    borderColor: "light-dark({green.500}, color-mix(in srgb, {green.700}, transparent 64%))",
    closeButton: {
      focusRing: {
        color: "{focus.ring.color}",
        shadow: "light-dark(0 0 0 0.2rem {green.200}, 0 0 0 0.2rem color-mix(in srgb, {green.500}, transparent 80%))"
      },
      hoverBackground: "light-dark({green.100}, rgba(255, 255, 255, 0.05))"
    },
    detailColor: "light-dark({surface.700}, {surface.0})"
  },
  contrast: {
    color: "light-dark({surface.50}, {surface.950})",
    shadow: "{overlay.popover.shadow}",
    background: "light-dark({surface.900}, {surface.0})",
    borderColor: "light-dark({primary.color}, {surface.100})",
    closeButton: {
      focusRing: {
        color: "{focus.ring.color}",
        shadow: "light-dark(0 0 0 0.2rem {surface.400}, 0 0 0 0.2rem color-mix(in srgb, {surface.950}, transparent 80%))"
      },
      hoverBackground: "light-dark({surface.800}, {surface.100})"
    },
    detailColor: "light-dark({surface.0}, {surface.950})"
  },
  secondary: {
    color: "light-dark({surface.600}, {surface.300})",
    shadow: "{overlay.popover.shadow}",
    background: "light-dark({surface.100}, {surface.800})",
    borderColor: "light-dark({surface.500}, {surface.700})",
    closeButton: {
      focusRing: {
        color: "{focus.ring.color}",
        shadow: "light-dark(0 0 0 0.2rem {surface.200}, 0 0 0 0.2rem color-mix(in srgb, {surface.300}, transparent 80%))"
      },
      hoverBackground: "light-dark({surface.200}, {surface.700})"
    },
    detailColor: "light-dark({surface.700}, {surface.0})"
  }
};

// theme/ts/avatar.ts
var avatar_default = {
  lg: {
    icon: {
      size: "1.5rem"
    },
    group: {
      offset: "-1rem"
    },
    width: "3rem",
    height: "3rem",
    fontSize: "1.5rem"
  },
  xl: {
    icon: {
      size: "2rem"
    },
    group: {
      offset: "-1.5rem"
    },
    width: "4rem",
    height: "4rem",
    fontSize: "2rem"
  },
  icon: {
    size: "1rem"
  },
  root: {
    color: "{content.color}",
    width: "2rem",
    height: "2rem",
    fontSize: "1rem",
    background: "{content.border.color}",
    borderRadius: "{content.border.radius}"
  },
  group: {
    offset: "-0.75rem",
    borderColor: "{content.background}"
  }
};

// theme/ts/button.ts
var button_default = {
  root: {
    lg: {
      fontSize: "{form.field.lg.font.size}",
      paddingX: "{form.field.lg.padding.x}",
      paddingY: "{form.field.lg.padding.y}",
      iconOnlyWidth: "3.25rem"
    },
    sm: {
      fontSize: "{form.field.sm.font.size}",
      paddingX: "{form.field.sm.padding.x}",
      paddingY: "{form.field.sm.padding.y}",
      iconOnlyWidth: "2.25rem"
    },
    gap: "0.5rem",
    label: {
      fontWeight: "600"
    },
    paddingX: "1rem",
    paddingY: "{form.field.padding.y}",
    badgeSize: "1rem",
    focusRing: {
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}"
    },
    borderRadius: "{form.field.border.radius}",
    raisedShadow: "0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
    iconOnlyWidth: "2.75rem",
    transitionDuration: "{form.field.transition.duration}",
    roundedBorderRadius: "2rem",
    help: {
      color: "light-dark(#ffffff, {purple.950})",
      focusRing: {
        color: "transparent",
        shadow: "light-dark(0 0 0 0.2rem {purple.200}, 0 0 0 0.2rem color-mix(in srgb, {purple.400}, transparent 80%))"
      },
      background: "light-dark({purple.500}, {purple.400})",
      hoverColor: "light-dark(#ffffff, {purple.950})",
      activeColor: "light-dark(#ffffff, {purple.950})",
      borderColor: "light-dark({purple.500}, {purple.400})",
      hoverBackground: "light-dark({purple.600}, {purple.300})",
      activeBackground: "light-dark({purple.700}, {purple.200})",
      hoverBorderColor: "light-dark({purple.600}, {purple.300})",
      activeBorderColor: "light-dark({purple.700}, {purple.200})"
    },
    info: {
      color: "light-dark(#ffffff, {sky.950})",
      focusRing: {
        color: "transparent",
        shadow: "light-dark(0 0 0 0.2rem {sky.200}, 0 0 0 0.2rem color-mix(in srgb, {sky.400}, transparent 80%))"
      },
      background: "light-dark({sky.500}, {sky.400})",
      hoverColor: "light-dark(#ffffff, {sky.950})",
      activeColor: "light-dark(#ffffff, {sky.950})",
      borderColor: "light-dark({sky.500}, {sky.400})",
      hoverBackground: "light-dark({sky.600}, {sky.300})",
      activeBackground: "light-dark({sky.700}, {sky.200})",
      hoverBorderColor: "light-dark({sky.600}, {sky.300})",
      activeBorderColor: "light-dark({sky.700}, {sky.200})"
    },
    warn: {
      color: "light-dark(#ffffff, {orange.950})",
      focusRing: {
        color: "transparent",
        shadow: "light-dark(0 0 0 0.2rem {orange.200}, 0 0 0 0.2rem color-mix(in srgb, {orange.400}, transparent 80%))"
      },
      background: "light-dark({orange.500}, {orange.400})",
      hoverColor: "light-dark(#ffffff, {orange.950})",
      activeColor: "light-dark(#ffffff, {orange.950})",
      borderColor: "light-dark({orange.500}, {orange.400})",
      hoverBackground: "light-dark({orange.600}, {orange.300})",
      activeBackground: "light-dark({orange.700}, {orange.200})",
      hoverBorderColor: "light-dark({orange.600}, {orange.300})",
      activeBorderColor: "light-dark({orange.700}, {orange.200})"
    },
    danger: {
      color: "light-dark(#ffffff, {red.950})",
      focusRing: {
        color: "transparent",
        shadow: "light-dark(0 0 0 0.2rem {red.200}, 0 0 0 0.2rem color-mix(in srgb, {red.400}, transparent 80%))"
      },
      background: "light-dark({red.500}, {red.400})",
      hoverColor: "light-dark(#ffffff, {red.950})",
      activeColor: "light-dark(#ffffff, {red.950})",
      borderColor: "light-dark({red.500}, {red.400})",
      hoverBackground: "light-dark({red.600}, {red.300})",
      activeBackground: "light-dark({red.700}, {red.200})",
      hoverBorderColor: "light-dark({red.600}, {red.300})",
      activeBorderColor: "light-dark({red.700}, {red.200})"
    },
    primary: {
      color: "{primary.contrast.color}",
      focusRing: {
        color: "transparent",
        shadow: "light-dark(0 0 0 0.2rem {primary.200}, 0 0 0 0.2rem color-mix(in srgb, {primary.color}, transparent 80%))"
      },
      background: "{primary.color}",
      hoverColor: "{primary.contrast.color}",
      activeColor: "{primary.contrast.color}",
      borderColor: "{primary.color}",
      hoverBackground: "{primary.hover.color}",
      activeBackground: "{primary.active.color}",
      hoverBorderColor: "{primary.hover.color}",
      activeBorderColor: "{primary.active.color}"
    },
    success: {
      color: "light-dark(#ffffff, {green.950})",
      focusRing: {
        color: "transparent",
        shadow: "light-dark(0 0 0 0.2rem {green.200}, 0 0 0 0.2rem color-mix(in srgb, {green.400}, transparent 80%))"
      },
      background: "light-dark({green.500}, {green.400})",
      hoverColor: "light-dark(#ffffff, {green.950})",
      activeColor: "light-dark(#ffffff, {green.950})",
      borderColor: "light-dark({green.500}, {green.400})",
      hoverBackground: "light-dark({green.600}, {green.300})",
      activeBackground: "light-dark({green.700}, {green.200})",
      hoverBorderColor: "light-dark({green.600}, {green.300})",
      activeBorderColor: "light-dark({green.700}, {green.200})"
    },
    contrast: {
      color: "light-dark({surface.0}, {surface.950})",
      focusRing: {
        color: "transparent",
        shadow: "light-dark(0 0 0 0.2rem {surface.400}, 0 0 0 0.2rem color-mix(in srgb, {surface.0}, transparent 80%))"
      },
      background: "light-dark({surface.950}, {surface.0})",
      hoverColor: "light-dark({surface.0}, {surface.950})",
      activeColor: "light-dark({surface.0}, {surface.950})",
      borderColor: "light-dark({surface.950}, {surface.0})",
      hoverBackground: "light-dark({surface.900}, {surface.100})",
      activeBackground: "light-dark({surface.800}, {surface.200})",
      hoverBorderColor: "light-dark({surface.900}, {surface.100})",
      activeBorderColor: "light-dark({surface.800}, {surface.200})"
    },
    secondary: {
      color: "light-dark({surface.800}, {surface.300})",
      focusRing: {
        color: "transparent",
        shadow: "light-dark(0 0 0 0.2rem {surface.200}, 0 0 0 0.2rem color-mix(in srgb, {surface.300}, transparent 80%))"
      },
      background: "light-dark({amber.400}, {surface.800})",
      hoverColor: "light-dark({surface.800}, {surface.200})",
      activeColor: "light-dark({surface.800}, {surface.100})",
      borderColor: "light-dark({amber.400}, {surface.800})",
      hoverBackground: "light-dark({amber.300}, {surface.700})",
      activeBackground: "light-dark({amber.200}, {surface.600})",
      hoverBorderColor: "light-dark({amber.300}, {surface.700})",
      activeBorderColor: "light-dark({amber.200}, {surface.600})"
    }
  },
  link: {
    color: "{primary.color}",
    hoverColor: "{primary.color}",
    activeColor: "{primary.color}"
  },
  text: {
    help: {
      color: "light-dark({purple.500}, {purple.400})",
      hoverBackground: "light-dark({purple.50}, color-mix(in srgb, {purple.400}, transparent 96%))",
      activeBackground: "light-dark({purple.100}, color-mix(in srgb, {purple.400}, transparent 84%))"
    },
    info: {
      color: "light-dark({sky.500}, {sky.400})",
      hoverBackground: "light-dark({sky.50}, color-mix(in srgb, {sky.400}, transparent 96%))",
      activeBackground: "light-dark({sky.100}, color-mix(in srgb, {sky.400}, transparent 84%))"
    },
    warn: {
      color: "light-dark({orange.500}, {orange.400})",
      hoverBackground: "light-dark({orange.50}, color-mix(in srgb, {orange.400}, transparent 96%))",
      activeBackground: "light-dark({orange.100}, color-mix(in srgb, {orange.400}, transparent 84%))"
    },
    plain: {
      color: "light-dark({surface.700}, {surface.0})",
      hoverBackground: "light-dark({surface.50}, {surface.800})",
      activeBackground: "light-dark({surface.100}, {surface.700})"
    },
    danger: {
      color: "light-dark({red.500}, {red.400})",
      hoverBackground: "light-dark({red.50}, color-mix(in srgb, {red.400}, transparent 96%))",
      activeBackground: "light-dark({red.100}, color-mix(in srgb, {red.400}, transparent 84%))"
    },
    primary: {
      color: "{primary.color}",
      hoverBackground: "light-dark({primary.50}, color-mix(in srgb, {primary.color}, transparent 96%))",
      activeBackground: "light-dark({primary.100}, color-mix(in srgb, {primary.color}, transparent 84%))"
    },
    success: {
      color: "light-dark({green.500}, {green.400})",
      hoverBackground: "light-dark({green.50}, color-mix(in srgb, {green.400}, transparent 96%))",
      activeBackground: "light-dark({green.100}, color-mix(in srgb, {green.400}, transparent 84%))"
    },
    contrast: {
      color: "light-dark({surface.950}, {surface.0})",
      hoverBackground: "light-dark({surface.50}, {surface.800})",
      activeBackground: "light-dark({surface.100}, {surface.700})"
    },
    secondary: {
      color: "light-dark({amber.600}, {surface.300})",
      hoverBackground: "light-dark({amber.100}, {surface.700})",
      activeBackground: "light-dark({amber.200}, {surface.600})"
    }
  },
  outlined: {
    help: {
      color: "light-dark({purple.500}, {purple.400})",
      borderColor: "light-dark({purple.500}, {purple.700})",
      hoverBackground: "{purple.100}",
      activeBackground: "{purple.200}"
    },
    info: {
      color: "light-dark({sky.500}, {sky.400})",
      borderColor: "light-dark({sky.500}, {sky.700})",
      hoverBackground: "{sky.100}",
      activeBackground: "{sky.200}"
    },
    warn: {
      color: "light-dark({orange.500}, {orange.400})",
      borderColor: "light-dark({orange.500}, {orange.700})",
      hoverBackground: "{orange.100}",
      activeBackground: "{orange.200}"
    },
    plain: {
      color: "light-dark({surface.700}, {surface.0})",
      borderColor: "light-dark({surface.200}, {surface.600})",
      hoverBackground: "light-dark({surface.100}, {surface.800})",
      activeBackground: "light-dark({surface.200}, {surface.700})"
    },
    danger: {
      color: "light-dark({red.500}, {red.400})",
      borderColor: "light-dark({red.500}, {red.700})",
      hoverBackground: "{red.100}",
      activeBackground: "{red.200}"
    },
    primary: {
      color: "{primary.color}",
      borderColor: "light-dark({primary.color}, {primary.700})",
      hoverBackground: "{primary.100}",
      activeBackground: "{primary.200}"
    },
    success: {
      color: "light-dark({green.500}, {green.400})",
      borderColor: "{green.500}",
      hoverBackground: "{green.100}",
      activeBackground: "{green.200}"
    },
    contrast: {
      color: "light-dark({surface.950}, {surface.0})",
      borderColor: "light-dark({surface.700}, {surface.500})",
      hoverBackground: "light-dark({surface.100}, {surface.800})",
      activeBackground: "light-dark({surface.200}, {surface.700})"
    },
    secondary: {
      color: "light-dark({amber.600}, {surface.400})",
      borderColor: "light-dark({amber.600}, {surface.700})",
      hoverBackground: "light-dark({amber.100}, rgba(255,255,255,0.04))",
      activeBackground: "light-dark({amber.200}, rgba(255,255,255,0.16))"
    }
  }
};

// theme/ts/dialog.ts
var dialog_default = {
  root: {
    color: "{overlay.modal.color}",
    shadow: "{overlay.modal.shadow}",
    background: "{overlay.modal.background}",
    borderColor: "{overlay.modal.border.color}",
    borderRadius: "{overlay.modal.border.radius}"
  },
  title: {
    fontSize: "1.25rem",
    fontWeight: "600"
  },
  footer: {
    gap: "0.5rem",
    padding: "0 {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}"
  },
  header: {
    gap: "0.5rem",
    padding: "{overlay.modal.padding}"
  },
  content: {
    padding: "0 {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}"
  }
};

// theme/ts/drawer.ts
var drawer_default = {
  root: {
    color: "{overlay.modal.color}",
    shadow: "{overlay.modal.shadow}",
    background: "{overlay.modal.background}",
    borderColor: "{overlay.modal.border.color}"
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: "600"
  },
  footer: {
    padding: "{overlay.modal.padding}"
  },
  header: {
    padding: "{overlay.modal.padding}"
  },
  content: {
    padding: "0 {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}"
  }
};

// theme/ts/editor.ts
var editor_default = {
  content: {
    color: "{content.color}",
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}"
  },
  overlay: {
    color: "{overlay.select.color}",
    shadow: "{overlay.select.shadow}",
    padding: "{list.padding}",
    background: "{overlay.select.background}",
    borderColor: "{overlay.select.border.color}",
    borderRadius: "{overlay.select.border.radius}"
  },
  toolbar: {
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    background: "light-dark({surface.50}, {surface.800})"
  },
  toolbarItem: {
    color: "{text.muted.color}",
    hoverColor: "{text.color}",
    activeColor: "{primary.color}"
  },
  overlayOption: {
    color: "{list.option.color}",
    padding: "{list.option.padding}",
    focusColor: "{list.option.focus.color}",
    borderRadius: "{list.option.border.radius}",
    focusBackground: "{list.option.focus.background}"
  }
};

// theme/ts/rating.ts
var rating_default = {
  icon: {
    size: "1.25rem",
    color: "{text.muted.color}",
    hoverColor: "{primary.color}",
    activeColor: "{primary.color}"
  },
  root: {
    gap: "0.25rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    transitionDuration: "{transition.duration}"
  }
};

// theme/ts/ripple.ts
var ripple_default = {
  root: {
    background: "light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.3))"
  }
};

// theme/ts/select.ts
var select_default = {
  list: {
    gap: "{list.gap}",
    header: {
      padding: "{list.header.padding}"
    },
    padding: "{list.padding}"
  },
  root: {
    lg: {
      fontSize: "{form.field.lg.font.size}",
      paddingX: "{form.field.lg.padding.x}",
      paddingY: "{form.field.lg.padding.y}"
    },
    sm: {
      fontSize: "{form.field.sm.font.size}",
      paddingX: "{form.field.sm.padding.x}",
      paddingY: "{form.field.sm.padding.y}"
    },
    color: "{form.field.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    focusRing: {
      color: "{form.field.focus.ring.color}",
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    background: "{form.field.background}",
    borderColor: "{form.field.border.color}",
    borderRadius: "{form.field.border.radius}",
    disabledColor: "{form.field.disabled.color}",
    filledBackground: "{form.field.filled.background}",
    focusBorderColor: "{form.field.focus.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    placeholderColor: "{form.field.placeholder.color}",
    disabledBackground: "{form.field.disabled.background}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    transitionDuration: "{form.field.transition.duration}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    filledHoverBackground: "{form.field.filled.hover.background}",
    invalidPlaceholderColor: "{form.field.invalid.placeholder.color}"
  },
  option: {
    color: "{list.option.color}",
    padding: "{list.option.padding}",
    focusColor: "{list.option.focus.color}",
    borderRadius: "{list.option.border.radius}",
    selectedColor: "{list.option.selected.color}",
    focusBackground: "{list.option.focus.background}",
    selectedBackground: "{list.option.selected.background}",
    selectedFocusColor: "{list.option.selected.focus.color}",
    selectedFocusBackground: "{list.option.selected.focus.background}"
  },
  overlay: {
    color: "{overlay.select.color}",
    shadow: "{overlay.select.shadow}",
    background: "{overlay.select.background}",
    borderColor: "{overlay.select.border.color}",
    borderRadius: "{overlay.select.border.radius}"
  },
  dropdown: {
    color: "{form.field.icon.color}",
    width: "2.5rem"
  },
  checkmark: {
    color: "{list.option.color}",
    gutterEnd: "0.5rem",
    gutterStart: "-0.5rem"
  },
  clearIcon: {
    color: "{form.field.icon.color}"
  },
  optionGroup: {
    color: "{list.option.group.color}",
    padding: "{list.option.group.padding}",
    background: "{list.option.group.background}",
    fontWeight: "{list.option.group.font.weight}"
  },
  emptyMessage: {
    padding: "{list.option.padding}"
  }
};

// theme/ts/slider.ts
var slider_default = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  range: {
    background: "{primary.color}"
  },
  track: {
    size: "3px",
    background: "{content.border.color}",
    borderRadius: "{content.border.radius}"
  },
  handle: {
    width: "16px",
    height: "16px",
    content: {
      width: "12px",
      height: "12px",
      shadow: "none",
      borderRadius: "50%",
      hoverBackground: "{primary.color}",
      background: "light-dark({surface.0}, {surface.950})"
    },
    focusRing: {
      color: "{form.field.focus.ring.color}",
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    background: "{primary.color}",
    borderRadius: "50%",
    hoverBackground: "{primary.color}"
  }
};

// theme/ts/blockui.ts
var blockui_default = {
  root: {
    borderRadius: "{content.border.radius}"
  }
};

// theme/ts/divider.ts
var divider_default = {
  root: {
    borderColor: "{content.border.color}"
  },
  content: {
    color: "{text.color}",
    background: "{content.background}"
  },
  vertical: {
    margin: "0 1.125rem",
    content: {
      padding: "0.625rem 0"
    },
    padding: "1.125rem 0"
  },
  horizontal: {
    margin: "1.125rem 0",
    content: {
      padding: "0 0.625rem"
    },
    padding: "0 1.125rem"
  }
};

// theme/ts/inplace.ts
var inplace_default = {
  root: {
    padding: "{form.field.padding.y} {form.field.padding.x}",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    borderRadius: "{content.border.radius}",
    transitionDuration: "{transition.duration}"
  },
  display: {
    hoverColor: "{content.hover.color}",
    hoverBackground: "{content.hover.background}"
  }
};

// theme/ts/listbox.ts
var listbox_default = {
  list: {
    gap: "{list.gap}",
    header: {
      padding: "{list.header.padding}"
    },
    padding: "{list.padding}"
  },
  root: {
    color: "{form.field.color}",
    shadow: "{form.field.shadow}",
    background: "{form.field.background}",
    borderColor: "{form.field.border.color}",
    borderRadius: "{form.field.border.radius}",
    disabledColor: "{form.field.disabled.color}",
    disabledBackground: "{form.field.disabled.background}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    transitionDuration: "{form.field.transition.duration}"
  },
  option: {
    color: "{list.option.color}",
    padding: "{list.option.padding}",
    focusColor: "{list.option.focus.color}",
    borderRadius: "{list.option.border.radius}",
    selectedColor: "{list.option.selected.color}",
    focusBackground: "{list.option.focus.background}",
    selectedBackground: "{list.option.selected.background}",
    selectedFocusColor: "{list.option.selected.focus.color}",
    selectedFocusBackground: "{list.option.selected.focus.background}",
    stripedBackground: "light-dark({surface.50}, {surface.900})"
  },
  checkmark: {
    color: "{list.option.color}",
    gutterEnd: "0.5rem",
    gutterStart: "-0.5rem"
  },
  optionGroup: {
    color: "{list.option.group.color}",
    padding: "{list.option.group.padding}",
    background: "{list.option.group.background}",
    fontWeight: "{list.option.group.font.weight}"
  },
  emptyMessage: {
    padding: "{list.option.padding}"
  }
};

// theme/ts/menubar.ts
var menubar_default = {
  item: {
    gap: "{navigation.item.gap}",
    icon: {
      color: "{navigation.item.icon.color}",
      focusColor: "{navigation.item.icon.focus.color}",
      activeColor: "{navigation.item.icon.active.color}"
    },
    color: "{navigation.item.color}",
    padding: "{navigation.item.padding}",
    focusColor: "{navigation.item.focus.color}",
    activeColor: "{navigation.item.active.color}",
    borderRadius: "{navigation.item.border.radius}",
    focusBackground: "{navigation.item.focus.background}",
    activeBackground: "{navigation.item.active.background}"
  },
  root: {
    gap: "0.5rem",
    color: "{content.color}",
    padding: "0.75rem 1rem",
    borderColor: "transparent",
    borderRadius: "{content.border.radius}",
    transitionDuration: "{transition.duration}",
    background: "light-dark({surface.50}, {surface.800})"
  },
  submenu: {
    gap: "{navigation.list.gap}",
    icon: {
      size: "{navigation.submenu.icon.size}",
      color: "{navigation.submenu.icon.color}",
      focusColor: "{navigation.submenu.icon.focus.color}",
      activeColor: "{navigation.submenu.icon.active.color}"
    },
    shadow: "{overlay.navigation.shadow}",
    padding: "{navigation.list.padding}",
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    mobileIndent: "1.25rem"
  },
  baseItem: {
    padding: "0.75rem 1rem",
    borderRadius: "{content.border.radius}"
  },
  separator: {
    borderColor: "{content.border.color}"
  },
  mobileButton: {
    size: "2rem",
    color: "{text.muted.color}",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    hoverColor: "{text.hover.muted.color}",
    borderRadius: "50%",
    hoverBackground: "{content.hover.background}"
  }
};

// theme/ts/message.ts
var message_default = {
  icon: {
    lg: {
      size: "1.5rem"
    },
    sm: {
      size: "1rem"
    },
    size: "1.25rem"
  },
  root: {
    borderWidth: "1px",
    borderRadius: "{content.border.radius}",
    transitionDuration: "{transition.duration}"
  },
  text: {
    lg: {
      fontSize: "1.125rem"
    },
    sm: {
      fontSize: "0.875rem"
    },
    fontSize: "1rem",
    fontWeight: "500"
  },
  simple: {
    content: {
      padding: "0"
    }
  },
  content: {
    lg: {
      padding: "0.75rem 0.875rem"
    },
    sm: {
      padding: "0.5rem 0.625rem"
    },
    gap: "0.5rem",
    padding: "0.75rem 1rem"
  },
  outlined: {
    root: {
      borderWidth: "1px"
    }
  },
  closeIcon: {
    lg: {
      size: "1.125rem"
    },
    sm: {
      size: "0.875rem"
    },
    size: "1rem"
  },
  closeButton: {
    width: "2rem",
    height: "2rem",
    focusRing: {
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}"
    },
    borderRadius: "50%"
  },
  info: {
    color: "light-dark({blue.600}, {blue.500})",
    shadow: "none",
    simple: {
      color: "light-dark({blue.600}, {blue.500})"
    },
    outlined: {
      color: "light-dark({blue.600}, {blue.500})",
      borderColor: "light-dark({blue.600}, {blue.500})"
    },
    background: "light-dark(color-mix(in srgb, {blue.50}, transparent 5%), color-mix(in srgb, {blue.500}, transparent 84%))",
    borderColor: "transparent",
    closeButton: {
      focusRing: {
        color: "{focus.ring.color}",
        shadow: "light-dark(0 0 0 0.2rem {blue.200}, 0 0 0 0.2rem color-mix(in srgb, {blue.500}, transparent 80%))"
      },
      hoverBackground: "light-dark({blue.100}, rgba(255, 255, 255, 0.05))"
    }
  },
  warn: {
    color: "light-dark({yellow.600}, {yellow.500})",
    shadow: "none",
    simple: {
      color: "light-dark({yellow.600}, {yellow.500})"
    },
    outlined: {
      color: "light-dark({yellow.600}, {yellow.500})",
      borderColor: "light-dark({yellow.600}, {yellow.500})"
    },
    background: "light-dark(color-mix(in srgb,{yellow.50}, transparent 5%), color-mix(in srgb, {yellow.500}, transparent 84%))",
    borderColor: "transparent",
    closeButton: {
      focusRing: {
        color: "{focus.ring.color}",
        shadow: "light-dark(0 0 0 0.2rem {yellow.200}, 0 0 0 0.2rem color-mix(in srgb, {yellow.500}, transparent 80%))"
      },
      hoverBackground: "light-dark({yellow.100}, rgba(255, 255, 255, 0.05))"
    }
  },
  error: {
    color: "light-dark({red.600}, {red.500})",
    shadow: "none",
    simple: {
      color: "light-dark({red.600}, {red.500})"
    },
    outlined: {
      color: "light-dark({red.600}, {red.500})",
      borderColor: "light-dark({red.600}, {red.500})"
    },
    background: "light-dark(color-mix(in srgb, {red.50}, transparent 5%), color-mix(in srgb, {red.500}, transparent 84%))",
    borderColor: "transparent",
    closeButton: {
      focusRing: {
        color: "{focus.ring.color}",
        shadow: "light-dark(0 0 0 0.2rem {red.200}, 0 0 0 0.2rem color-mix(in srgb, {red.500}, transparent 80%))"
      },
      hoverBackground: "light-dark({red.100}, rgba(255, 255, 255, 0.05))"
    }
  },
  success: {
    color: "light-dark({green.600}, {green.500})",
    shadow: "none",
    simple: {
      color: "light-dark({green.600}, {green.500})"
    },
    outlined: {
      color: "light-dark({green.600}, {green.500})",
      borderColor: "light-dark({green.600}, {green.500})"
    },
    background: "light-dark(color-mix(in srgb, {green.50}, transparent 5%), color-mix(in srgb, {green.500}, transparent 84%))",
    borderColor: "transparent",
    closeButton: {
      focusRing: {
        color: "{focus.ring.color}",
        shadow: "light-dark(0 0 0 0.2rem {green.200}, 0 0 0 0.2rem color-mix(in srgb, {green.500}, transparent 80%))"
      },
      hoverBackground: "light-dark({green.100}, rgba(255, 255, 255, 0.05))"
    }
  },
  contrast: {
    color: "light-dark({surface.50}, {surface.950})",
    shadow: "none",
    simple: {
      color: "light-dark({surface.900}, {surface.0})"
    },
    outlined: {
      color: "light-dark({surface.900}, {surface.0})",
      borderColor: "light-dark({surface.900}, {surface.0})"
    },
    background: "light-dark({surface.900}, {surface.0})",
    borderColor: "transparent",
    closeButton: {
      focusRing: {
        color: "{focus.ring.color}",
        shadow: "light-dark(0 0 0 0.2rem {surface.400}, 0 0 0 0.2rem color-mix(in srgb, {surface.950}, transparent 80%))"
      },
      hoverBackground: "light-dark({surface.800}, {surface.100})"
    }
  },
  secondary: {
    color: "light-dark({surface.600}, {surface.300})",
    shadow: "none",
    simple: {
      color: "light-dark({surface.500}, {surface.400})"
    },
    outlined: {
      color: "light-dark({surface.500}, {surface.400})",
      borderColor: "light-dark({surface.500}, {surface.400})"
    },
    background: "light-dark({surface.100}, {surface.800})",
    borderColor: "transparent",
    closeButton: {
      focusRing: {
        color: "{focus.ring.color}",
        shadow: "light-dark(0 0 0 0.2rem {surface.200}, 0 0 0 0.2rem color-mix(in srgb, {surface.300}, transparent 80%))"
      },
      hoverBackground: "light-dark({surface.200}, {surface.700})"
    }
  }
};

// theme/ts/popover.ts
var popover_default = {
  root: {
    color: "{overlay.popover.color}",
    gutter: "10px",
    shadow: "{overlay.popover.shadow}",
    background: "{overlay.popover.background}",
    arrowOffset: "1.25rem",
    borderColor: "{overlay.popover.border.color}",
    borderRadius: "{overlay.popover.border.radius}"
  },
  content: {
    padding: "{overlay.popover.padding}"
  }
};

// theme/ts/stepper.ts
var stepper_default = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  step: {
    gap: "1rem",
    padding: "0.5rem"
  },
  separator: {
    size: "2px",
    margin: "0 0 0 1.625rem",
    background: "{content.border.color}",
    activeBackground: "{primary.color}"
  },
  stepTitle: {
    color: "{text.muted.color}",
    fontWeight: "500",
    activeColor: "{primary.color}"
  },
  steppanel: {
    color: "{content.color}",
    indent: "1rem",
    padding: "0",
    background: "{content.background}"
  },
  stepHeader: {
    gap: "0.5rem",
    padding: "0",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    borderRadius: "{content.border.radius}"
  },
  stepNumber: {
    size: "2.25rem",
    color: "{text.muted.color}",
    shadow: "none",
    fontSize: "1.125rem",
    background: "{content.background}",
    fontWeight: "500",
    activeColor: "{primary.contrast.color}",
    borderColor: "{content.border.color}",
    borderRadius: "50%",
    activeBackground: "{primary.color}",
    activeBorderColor: "{primary.color}"
  },
  steppanels: {
    padding: "0.875rem 0.5rem 1.125rem 0.5rem"
  }
};

// theme/ts/tabmenu.ts
var tabmenu_default = {
  item: {
    gap: "0.5rem",
    color: "{text.muted.color}",
    margin: "0",
    padding: "1rem 1.25rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    fontWeight: "600",
    hoverColor: "{text.color}",
    activeColor: "{primary.color}",
    borderColor: "transparent",
    borderWidth: "2px 0 0 0",
    hoverBorderColor: "transparent",
    activeBorderColor: "{primary.color}",
    background: "light-dark({surface.50}, {surface.800})",
    hoverBackground: "light-dark({surface.100}, {surface.700})",
    activeBackground: "light-dark({surface.0}, {surface.900})"
  },
  root: {
    transitionDuration: "{transition.duration}"
  },
  tablist: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderWidth: "0"
  },
  itemIcon: {
    color: "{text.muted.color}",
    hoverColor: "{text.color}",
    activeColor: "{primary.color}"
  },
  activeBar: {
    bottom: "0",
    height: "0",
    background: "transparent"
  }
};

// theme/ts/tabview.ts
var tabview_default = {
  tab: {
    color: "{text.muted.color}",
    hoverColor: "{text.color}",
    activeColor: "{primary.color}",
    borderColor: "{content.border.color}",
    activeBorderColor: "{primary.color}"
  },
  root: {
    transitionDuration: "{transition.duration}"
  },
  tabList: {
    background: "{content.background}",
    borderColor: "{content.border.color}"
  },
  tabPanel: {
    color: "{content.color}",
    background: "{content.background}"
  },
  navButton: {
    color: "{text.muted.color}",
    background: "{content.background}",
    hoverColor: "{text.color}",
    shadow: "light-dark(0px 0px 10px 50px rgba(255, 255, 255, 0.6), 0px 0px 10px 50px color-mix(in srgb, {content.background}, transparent 50%))"
  }
};

// theme/ts/toolbar.ts
var toolbar_default = {
  root: {
    gap: "0.5rem",
    color: "{content.color}",
    padding: "0.75rem",
    background: "light-dark({surface.50}, {surface.800})",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}"
  }
};

// theme/ts/tooltip.ts
var tooltip_default = {
  root: {
    gutter: "0.25rem",
    shadow: "{overlay.popover.shadow}",
    padding: "0.625rem 0.75rem",
    maxWidth: "12.5rem",
    borderRadius: "{overlay.popover.border.radius}",
    color: "{surface.0}",
    background: "{surface.700}"
  }
};

// theme/ts/carousel.ts
var carousel_default = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  content: {
    gap: "0.25rem"
  },
  indicator: {
    width: "1rem",
    height: "1rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    borderRadius: "50",
    background: "light-dark({surface.200}, {surface.700})",
    hoverBackground: "light-dark({surface.300}, {surface.600})",
    activeBackground: "{primary.color}"
  },
  indicatorList: {
    gap: "0.5rem",
    padding: "1rem"
  }
};

// theme/ts/checkbox.ts
var checkbox_default = {
  icon: {
    lg: {
      size: "1rem"
    },
    sm: {
      size: "0.5rem"
    },
    size: "0.75rem",
    color: "{form.field.color}",
    checkedColor: "{primary.contrast.color}",
    disabledColor: "{form.field.disabled.color}",
    checkedHoverColor: "{primary.contrast.color}"
  },
  root: {
    lg: {
      width: "1.5rem",
      height: "1.5rem"
    },
    sm: {
      width: "1rem",
      height: "1rem"
    },
    width: "1.25rem",
    height: "1.25rem",
    shadow: "{form.field.shadow}",
    focusRing: {
      color: "{form.field.focus.ring.color}",
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    background: "{form.field.background}",
    borderColor: "{form.field.border.color}",
    borderRadius: "{border.radius.sm}",
    filledBackground: "{form.field.filled.background}",
    focusBorderColor: "{form.field.focus.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    checkedBackground: "{primary.color}",
    checkedBorderColor: "{primary.color}",
    disabledBackground: "{form.field.disabled.background}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    transitionDuration: "{form.field.transition.duration}",
    checkedHoverBackground: "{primary.hover.color}",
    checkedFocusBorderColor: "{primary.color}",
    checkedHoverBorderColor: "{primary.hover.color}",
    checkedDisabledBorderColor: "{form.field.border.color}"
  }
};

// theme/ts/dataview.ts
var dataview_default = {
  root: {
    padding: "0",
    borderColor: "{content.border.color}",
    borderWidth: "1px",
    borderRadius: "4px"
  },
  footer: {
    color: "{content.color}",
    padding: "0.875rem 1.125rem",
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderWidth: "1px 0 0 0",
    borderRadius: "0 0 5px 5px"
  },
  header: {
    padding: "0.875rem 1.125rem",
    borderColor: "{content.border.color}",
    borderWidth: "0 0 1px 0",
    borderRadius: "5px 5px 0 0",
    color: "{text.color}",
    background: "light-dark({surface.50}, {surface.800})"
  },
  content: {
    color: "{content.color}",
    padding: "0",
    background: "{content.background}",
    borderColor: "transparent",
    borderWidth: "0",
    borderRadius: "5px"
  },
  paginatorTop: {
    borderColor: "{content.border.color}",
    borderWidth: "0 0 1px 0"
  },
  paginatorBottom: {
    borderColor: "{content.border.color}",
    borderWidth: "1px 0 0 0"
  }
};

// theme/ts/fieldset.ts
var fieldset_default = {
  root: {
    color: "{content.color}",
    padding: "0.75rem 1.125rem 1.125rem 1.125rem",
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    transitionDuration: "{transition.duration}"
  },
  legend: {
    gap: "0.5rem",
    padding: "0.625rem 0.875rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    fontWeight: "700",
    borderColor: "{content.border.color}",
    borderWidth: "1px",
    borderRadius: "{content.border.radius}",
    color: "{text.color}",
    background: "light-dark({surface.50}, {surface.800})",
    hoverColor: "{text.hover.color}",
    hoverBackground: "light-dark({surface.100}, {surface.700})"
  },
  content: {
    padding: "0"
  },
  toggleIcon: {
    color: "{text.muted.color}",
    hoverColor: "{text.hover.muted.color}"
  }
};

// theme/ts/galleria.ts
var galleria_default = {
  root: {
    borderColor: "{content.border.color}",
    borderWidth: "1px",
    borderRadius: "{content.border.radius}",
    transitionDuration: "{transition.duration}"
  },
  caption: {
    color: "{surface.100}",
    padding: "1rem",
    background: "rgba(0, 0, 0, 0.5)"
  },
  navIcon: {
    size: "1.5rem"
  },
  navButton: {
    next: {
      borderRadius: "12px 0 0 12px"
    },
    prev: {
      borderRadius: "0 12px 12px 0"
    },
    size: "3rem",
    color: "{surface.100}",
    gutter: "0",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    background: "rgba(255, 255, 255, 0.1)",
    hoverColor: "{surface.0}",
    hoverBackground: "rgba(255, 255, 255, 0.2)"
  },
  closeButton: {
    size: "3rem",
    color: "{surface.50}",
    gutter: "0.5rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    background: "rgba(255, 255, 255, 0.1)",
    hoverColor: "{surface.0}",
    borderRadius: "50%",
    hoverBackground: "rgba(255, 255, 255, 0.2)"
  },
  indicatorList: {
    gap: "0.5rem",
    padding: "1rem"
  },
  closeButtonIcon: {
    size: "1.5rem"
  },
  indicatorButton: {
    width: "1rem",
    height: "1rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    borderRadius: "50%",
    activeBackground: "{primary.color}",
    background: "light-dark({surface.200}, {surface.700})",
    hoverBackground: "light-dark({surface.300}, {surface.600})"
  },
  thumbnailsContent: {
    padding: "1rem 0.25rem",
    background: "light-dark({surface.50}, {surface.800})"
  },
  insetIndicatorList: {
    background: "rgba(0, 0, 0, 0.5)"
  },
  thumbnailNavButton: {
    size: "2rem",
    gutter: "0.5rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    borderRadius: "{content.border.radius}",
    color: "light-dark({surface.600}, {surface.400})",
    hoverColor: "light-dark({surface.700}, {surface.0})",
    hoverBackground: "light-dark({surface.100}, {surface.700})"
  },
  insetIndicatorButton: {
    background: "rgba(255, 255, 255, 0.4)",
    hoverBackground: "rgba(255, 255, 255, 0.6)",
    activeBackground: "rgba(255, 255, 255, 0.9)"
  },
  thumbnailNavButtonIcon: {
    size: "1rem"
  }
};

// theme/ts/inputotp.ts
var inputotp_default = {
  root: {
    gap: "0.5rem"
  },
  input: {
    lg: {
      width: "3rem"
    },
    sm: {
      width: "2rem"
    },
    width: "2.5rem"
  }
};

// theme/ts/megamenu.ts
var megamenu_default = {
  item: {
    gap: "{navigation.item.gap}",
    icon: {
      color: "{navigation.item.icon.color}",
      focusColor: "{navigation.item.icon.focus.color}",
      activeColor: "{navigation.item.icon.active.color}"
    },
    color: "{navigation.item.color}",
    padding: "{navigation.item.padding}",
    focusColor: "{navigation.item.focus.color}",
    activeColor: "{navigation.item.active.color}",
    borderRadius: "{navigation.item.border.radius}",
    focusBackground: "{navigation.item.focus.background}",
    activeBackground: "{navigation.item.active.background}"
  },
  root: {
    gap: "0.5rem",
    color: "{content.color}",
    borderColor: "transparent",
    borderRadius: "{content.border.radius}",
    transitionDuration: "{transition.duration}",
    verticalOrientation: {
      gap: "{navigation.list.gap}",
      padding: "{navigation.list.padding}"
    },
    horizontalOrientation: {
      gap: "0.5rem",
      padding: "0.75rem 1rem"
    },
    background: "light-dark({surface.50}, {surface.800})"
  },
  overlay: {
    gap: "0.5rem",
    color: "{content.color}",
    shadow: "{overlay.navigation.shadow}",
    padding: "0",
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}"
  },
  submenu: {
    gap: "{navigation.list.gap}",
    padding: "{navigation.list.padding}"
  },
  baseItem: {
    padding: "0.75rem 1rem",
    borderRadius: "{content.border.radius}"
  },
  separator: {
    borderColor: "{content.border.color}"
  },
  submenuIcon: {
    size: "{navigation.submenu.icon.size}",
    color: "{navigation.submenu.icon.color}",
    focusColor: "{navigation.submenu.icon.focus.color}",
    activeColor: "{navigation.submenu.icon.active.color}"
  },
  mobileButton: {
    size: "2rem",
    color: "{text.muted.color}",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    hoverColor: "{text.hover.muted.color}",
    borderRadius: "50%",
    hoverBackground: "{content.hover.background}"
  },
  submenuLabel: {
    color: "{navigation.submenu.label.color}",
    padding: "{navigation.submenu.label.padding}",
    background: "{navigation.submenu.label.background}",
    fontWeight: "{navigation.submenu.label.font.weight}"
  }
};

// theme/ts/password.ts
var password_default = {
  icon: {
    color: "{form.field.icon.color}"
  },
  meter: {
    height: ".75rem",
    background: "{content.border.color}",
    borderRadius: "{content.border.radius}"
  },
  content: {
    gap: "0.75rem"
  },
  overlay: {
    color: "{overlay.popover.color}",
    shadow: "{overlay.popover.shadow}",
    padding: "{overlay.popover.padding}",
    background: "{overlay.popover.background}",
    borderColor: "{overlay.popover.border.color}",
    borderRadius: "{overlay.popover.border.radius}"
  },
  strength: {
    weakBackground: "light-dark({red.500}, {red.400})",
    mediumBackground: "light-dark({amber.500}, {amber.400})",
    strongBackground: "light-dark({green.500}, {green.400})"
  }
};

// theme/ts/picklist.ts
var picklist_default = {
  root: {
    gap: "1.125rem"
  },
  controls: {
    gap: "0.5rem"
  }
};

// theme/ts/skeleton.ts
var skeleton_default = {
  root: {
    borderRadius: "{content.border.radius}",
    background: "light-dark({surface.200}, rgba(255, 255, 255, 0.06))",
    animationBackground: "light-dark(rgba(255,255,255,0.4), rgba(255, 255, 255, 0.04))"
  }
};

// theme/ts/splitter.ts
var splitter_default = {
  root: {
    color: "{content.color}",
    background: "{content.background}",
    borderColor: "{content.border.color}",
    transitionDuration: "{transition.duration}"
  },
  gutter: {
    background: "{content.border.color}"
  },
  handle: {
    size: "24px",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    borderRadius: "{content.border.radius}",
    background: "light-dark({surface.400}, {surface.600})"
  }
};

// theme/ts/terminal.ts
var terminal_default = {
  root: {
    color: "{form.field.color}",
    height: "18rem",
    padding: "{form.field.padding.y} {form.field.padding.x}",
    background: "{form.field.background}",
    borderColor: "{form.field.border.color}",
    borderRadius: "{form.field.border.radius}"
  },
  prompt: {
    gap: "0.25rem"
  },
  commandResponse: {
    margin: "2px 0"
  }
};

// theme/ts/textarea.ts
var textarea_default = {
  root: {
    lg: {
      fontSize: "{form.field.lg.font.size}",
      paddingX: "{form.field.lg.padding.x}",
      paddingY: "{form.field.lg.padding.y}"
    },
    sm: {
      fontSize: "{form.field.sm.font.size}",
      paddingX: "{form.field.sm.padding.x}",
      paddingY: "{form.field.sm.padding.y}"
    },
    color: "{form.field.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    focusRing: {
      color: "{form.field.focus.ring.color}",
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    background: "{form.field.background}",
    borderColor: "{form.field.border.color}",
    borderRadius: "{form.field.border.radius}",
    disabledColor: "{form.field.disabled.color}",
    filledBackground: "{form.field.filled.background}",
    focusBorderColor: "{form.field.focus.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    placeholderColor: "{form.field.placeholder.color}",
    disabledBackground: "{form.field.disabled.background}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    transitionDuration: "{form.field.transition.duration}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    filledHoverBackground: "{form.field.filled.hover.background}",
    invalidPlaceholderColor: "{form.field.invalid.placeholder.color}"
  }
};

// theme/ts/timeline.ts
var timeline_default = {
  event: {
    minHeight: "5rem"
  },
  vertical: {
    eventContent: {
      padding: "0 1rem"
    }
  },
  horizontal: {
    eventContent: {
      padding: "1rem 0"
    }
  },
  eventMarker: {
    size: "1.125rem",
    content: {
      size: "0.375rem",
      background: "transparent",
      insetShadow: "none",
      borderRadius: "50%"
    },
    background: "{content.background}",
    borderColor: "{primary.color}",
    borderWidth: "2px",
    borderRadius: "50%"
  },
  eventConnector: {
    size: "2px",
    color: "{content.border.color}"
  }
};

// theme/ts/accordion.ts
var accordion_default = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  panel: {
    borderColor: "{content.border.color}",
    borderWidth: "0"
  },
  header: {
    last: {
      bottomBorderRadius: "{content.border.radius}",
      activeBottomBorderRadius: "0"
    },
    color: "{text.muted.color}",
    first: {
      borderWidth: "1px",
      topBorderRadius: "{content.border.radius}"
    },
    padding: "1.125rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "inset {focus.ring.shadow}"
    },
    fontWeight: "700",
    hoverColor: "{text.color}",
    toggleIcon: {
      color: "{text.muted.color}",
      hoverColor: "{text.color}",
      activeColor: "{text.color}",
      activeHoverColor: "{text.color}"
    },
    activeColor: "{text.color}",
    borderColor: "{content.border.color}",
    borderWidth: "0 1px 1px 1px",
    borderRadius: "0",
    activeHoverColor: "{text.color}",
    background: "light-dark({surface.50}, {surface.800})",
    hoverBackground: "light-dark({surface.100}, {surface.700})",
    activeBackground: "light-dark({surface.50}, {surface.800})",
    activeHoverBackground: "light-dark({surface.100}, {surface.700})"
  },
  content: {
    color: "{text.color}",
    padding: "1.125rem",
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderWidth: "0 1px 1px 1px"
  }
};

// theme/ts/datatable.ts
var datatable_default = {
  row: {
    color: "{content.color}",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "inset {focus.ring.shadow}"
    },
    background: "{content.background}",
    hoverColor: "{content.hover.color}",
    selectedColor: "{highlight.color}",
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{highlight.background}",
    stripedBackground: "light-dark({surface.50}, {surface.950})"
  },
  root: {
    transitionDuration: "{transition.duration}",
    borderColor: "light-dark({content.border.color}, {surface.800})"
  },
  filter: {
    rule: {
      borderColor: "{content.border.color}"
    },
    inlineGap: "0.5rem",
    constraint: {
      color: "{list.option.color}",
      padding: "{list.option.padding}",
      separator: {
        borderColor: "{content.border.color}"
      },
      focusColor: "{list.option.focus.color}",
      borderRadius: "{list.option.border.radius}",
      selectedColor: "{list.option.selected.color}",
      focusBackground: "{list.option.focus.background}",
      selectedBackground: "{list.option.selected.background}",
      selectedFocusColor: "{list.option.selected.focus.color}",
      selectedFocusBackground: "{list.option.selected.focus.background}"
    },
    overlaySelect: {
      color: "{overlay.select.color}",
      shadow: "{overlay.select.shadow}",
      background: "{overlay.select.background}",
      borderColor: "{overlay.select.border.color}",
      borderRadius: "{overlay.select.border.radius}"
    },
    constraintList: {
      gap: "{list.gap}",
      padding: "{list.padding}"
    },
    overlayPopover: {
      gap: "0.5rem",
      color: "{overlay.popover.color}",
      shadow: "{overlay.popover.shadow}",
      padding: "{overlay.popover.padding}",
      background: "{overlay.popover.background}",
      borderColor: "{overlay.popover.border.color}",
      borderRadius: "{overlay.popover.border.radius}"
    }
  },
  footer: {
    lg: {
      padding: "1rem 1.25rem"
    },
    sm: {
      padding: "0.375rem 0.5rem"
    },
    padding: "0.75rem 1rem",
    borderColor: "{datatable.border.color}",
    borderWidth: "0",
    color: "{text.color}",
    background: "light-dark({surface.50}, {surface.800})"
  },
  header: {
    lg: {
      padding: "1rem 1.25rem"
    },
    sm: {
      padding: "0.5rem 0.5rem"
    },
    padding: "1rem",
    borderColor: "{datatable.border.color}",
    borderWidth: "1px 0 1px 0",
    color: "{text.color}",
    background: "light-dark({surface.50}, {surface.800})"
  },
  bodyCell: {
    lg: {
      padding: "1rem 1.25rem"
    },
    sm: {
      padding: "0.5rem 0.5rem"
    },
    padding: "0.75rem 1rem",
    borderColor: "{datatable.border.color}",
    selectedBorderColor: "light-dark({primary.100}, {primary.900})"
  },
  sortIcon: {
    size: "0.875rem",
    color: "{text.muted.color}",
    hoverColor: "{text.hover.muted.color}"
  },
  dropPoint: {
    color: "{primary.color}"
  },
  footerCell: {
    lg: {
      padding: "1rem 1.25rem"
    },
    sm: {
      padding: "0.375rem 0.5rem"
    },
    padding: "0.75rem 1rem",
    borderColor: "{datatable.border.color}",
    color: "{text.color}",
    background: "light-dark({surface.50}, {surface.800})"
  },
  headerCell: {
    lg: {
      padding: "1rem 1.25rem"
    },
    sm: {
      padding: ".5rem"
    },
    gap: "0.5rem",
    padding: "1rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "inset {focus.ring.shadow}"
    },
    hoverColor: "{content.hover.color}",
    borderColor: "{datatable.border.color}",
    selectedColor: "{highlight.color}",
    selectedBackground: "{highlight.background}",
    color: "{text.color}",
    background: "light-dark({surface.50}, {surface.800})",
    hoverBackground: "light-dark({surface.100}, {surface.700})"
  },
  columnTitle: {
    fontWeight: "700"
  },
  loadingIcon: {
    size: "2rem"
  },
  columnFooter: {
    fontWeight: "700"
  },
  paginatorTop: {
    borderColor: "{datatable.border.color}",
    borderWidth: "0 0 1px 0"
  },
  columnResizer: {
    width: "0.5rem"
  },
  paginatorBottom: {
    borderColor: "{datatable.border.color}",
    borderWidth: "0 0 1px 0"
  },
  resizeIndicator: {
    color: "{primary.color}",
    width: "1px"
  },
  rowToggleButton: {
    size: "1.75rem",
    color: "{text.muted.color}",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    hoverColor: "{text.color}",
    borderRadius: "50%",
    hoverBackground: "{content.hover.background}",
    selectedHoverColor: "{primary.color}",
    selectedHoverBackground: "{content.background}"
  }
};

// theme/ts/iconfield.ts
var iconfield_default = {
  icon: {
    color: "{form.field.icon.color}"
  }
};

// theme/ts/iftalabel.ts
var iftalabel_default = {
  root: {
    top: "{form.field.padding.y}",
    color: "{form.field.float.label.color}",
    fontSize: "0.75rem",
    positionX: "{form.field.padding.x}",
    focusColor: "{form.field.float.label.focus.color}",
    fontWeight: "400",
    invalidColor: "{form.field.float.label.invalid.color}",
    transitionDuration: "0.2s"
  },
  input: {
    paddingTop: "1.875rem",
    paddingBottom: "{form.field.padding.y}"
  }
};

// theme/ts/inputtext.ts
var inputtext_default = {
  root: {
    lg: {
      fontSize: "{form.field.lg.font.size}",
      paddingX: "{form.field.lg.padding.x}",
      paddingY: "{form.field.lg.padding.y}"
    },
    sm: {
      fontSize: "{form.field.sm.font.size}",
      paddingX: "{form.field.sm.padding.x}",
      paddingY: "{form.field.sm.padding.y}"
    },
    color: "{form.field.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    focusRing: {
      color: "{form.field.focus.ring.color}",
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    background: "{form.field.background}",
    borderColor: "{form.field.border.color}",
    borderRadius: "{form.field.border.radius}",
    disabledColor: "{form.field.disabled.color}",
    filledBackground: "{form.field.filled.background}",
    focusBorderColor: "{form.field.focus.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    placeholderColor: "{form.field.placeholder.color}",
    disabledBackground: "{form.field.disabled.background}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    transitionDuration: "{form.field.transition.duration}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    filledHoverBackground: "{form.field.filled.hover.background}",
    invalidPlaceholderColor: "{form.field.invalid.placeholder.color}"
  }
};

// theme/ts/orderlist.ts
var orderlist_default = {
  root: {
    gap: "1.125rem"
  },
  controls: {
    gap: "0.5rem"
  }
};

// theme/ts/paginator.ts
var paginator_default = {
  root: {
    gap: "0.25rem",
    color: "{content.color}",
    padding: "0.5rem 1rem",
    background: "{content.background}",
    borderRadius: "{content.border.radius}",
    transitionDuration: "{transition.duration}"
  },
  navButton: {
    color: "{text.muted.color}",
    width: "2.5rem",
    height: "2.5rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    background: "transparent",
    hoverColor: "{text.hover.muted.color}",
    borderRadius: "50%",
    selectedColor: "{highlight.color}",
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{highlight.background}"
  },
  jumpToPageInput: {
    maxWidth: "2.5rem"
  },
  currentPageReport: {
    color: "{text.muted.color}"
  }
};

// theme/ts/panelmenu.ts
var panelmenu_default = {
  item: {
    gap: "0.5rem",
    icon: {
      color: "{navigation.item.icon.color}",
      focusColor: "{navigation.item.icon.focus.color}"
    },
    color: "{navigation.item.color}",
    padding: "{navigation.item.padding}",
    focusColor: "{navigation.item.focus.color}",
    borderRadius: "{content.border.radius}",
    focusBackground: "{navigation.item.focus.background}"
  },
  root: {
    gap: "0",
    transitionDuration: "{transition.duration}"
  },
  panel: {
    last: {
      borderWidth: "0 1px 1px 1px",
      bottomBorderRadius: "{content.border.radius}"
    },
    color: "{content.color}",
    first: {
      borderWidth: "1px 1px 0 1px",
      topBorderRadius: "{content.border.radius}"
    },
    padding: "0.25rem 0.25rem",
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderWidth: "1px",
    borderRadius: "0"
  },
  submenu: {
    indent: "1rem"
  },
  submenuIcon: {
    color: "{navigation.submenu.icon.color}",
    focusColor: "{navigation.submenu.icon.focus.color}"
  }
};

// theme/ts/speeddial.ts
var speeddial_default = {
  root: {
    gap: "0.5rem",
    transitionDuration: "{transition.duration}"
  }
};

// theme/ts/treetable.ts
var treetable_default = {
  row: {
    color: "{content.color}",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "inset {focus.ring.shadow}"
    },
    background: "{content.background}",
    hoverColor: "{sr.hover.color}",
    selectedColor: "{highlight.color}",
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{highlight.background}"
  },
  root: {
    transitionDuration: "{transition.duration}",
    borderColor: "light-dark({content.border.color}, {surface.800})"
  },
  footer: {
    padding: "0.75rem 1rem",
    borderColor: "{treetable.border.color}",
    borderWidth: "0 0 1px 0",
    color: "{text.color}",
    background: "light-dark({surface.50}, {surface.800})"
  },
  header: {
    padding: "0.75rem 1rem",
    borderColor: "{treetable.border.color}",
    borderWidth: "1px 0 1px 0",
    color: "{text.color}",
    background: "light-dark({surface.50}, {surface.800})"
  },
  bodyCell: {
    gap: "0.5rem",
    padding: "0.75rem 1rem",
    borderColor: "{treetable.border.color}",
    selectedBorderColor: "light-dark({primary.100}, {primary.900})"
  },
  sortIcon: {
    size: "0.875rem",
    color: "{text.muted.color}",
    hoverColor: "{text.hover.muted.color}"
  },
  footerCell: {
    padding: "0.75rem 1rem",
    borderColor: "{treetable.border.color}",
    color: "{text.color}",
    background: "light-dark({surface.50}, {surface.800})"
  },
  headerCell: {
    gap: "0.5rem",
    padding: "0.75rem 1rem",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "inset {focus.ring.shadow}"
    },
    hoverColor: "{content.hover.color}",
    borderColor: "{treetable.border.color}",
    selectedColor: "{highlight.color}",
    selectedBackground: "{highlight.background}",
    color: "{text.color}",
    background: "light-dark({surface.50}, {surface.800})",
    hoverBackground: "light-dark({surface.100}, {surface.700})"
  },
  columnTitle: {
    fontWeight: "700"
  },
  loadingIcon: {
    size: "2rem"
  },
  columnFooter: {
    fontWeight: "700"
  },
  paginatorTop: {
    borderColor: "{content.border.color}",
    borderWidth: "0 0 1px 0"
  },
  columnResizer: {
    width: "0.5rem"
  },
  paginatorBottom: {
    borderColor: "{content.border.color}",
    borderWidth: "0 0 1px 0"
  },
  resizeIndicator: {
    color: "{primary.color}",
    width: "1px"
  },
  nodeToggleButton: {
    size: "1.75rem",
    color: "{text.muted.color}",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    hoverColor: "{text.color}",
    borderRadius: "50%",
    hoverBackground: "{content.hover.background}",
    selectedHoverColor: "{primary.color}",
    selectedHoverBackground: "{content.background}"
  }
};

// theme/ts/breadcrumb.ts
var breadcrumb_default = {
  item: {
    gap: "{navigation.item.gap}",
    icon: {
      color: "{navigation.item.icon.color}",
      hoverColor: "{navigation.item.icon.focus.color}"
    },
    color: "{text.muted.color}",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    hoverColor: "{text.color}",
    borderRadius: "{content.border.radius}"
  },
  root: {
    gap: "0.5rem",
    padding: "1.25rem",
    background: "{content.background}",
    transitionDuration: "{transition.duration}"
  },
  separator: {
    color: "{navigation.item.icon.color}"
  }
};

// theme/ts/datepicker.ts
var datepicker_default = {
  date: {
    color: "{content.color}",
    width: "2.5rem",
    height: "2.5rem",
    padding: "0.375rem",
    focusRing: {
      color: "{form.field.focus.ring.color}",
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    hoverColor: "{content.hover.color}",
    borderRadius: "50%",
    selectedColor: "{primary.contrast.color}",
    hoverBackground: "{content.hover.background}",
    rangeSelectedColor: "{highlight.color}",
    selectedBackground: "{primary.color}",
    rangeSelectedBackground: "{highlight.background}"
  },
  root: {
    transitionDuration: "{transition.duration}"
  },
  year: {
    padding: "0.5rem",
    borderRadius: "{content.border.radius}"
  },
  group: {
    gap: "{overlay.popover.padding}",
    borderColor: "{content.border.color}"
  },
  month: {
    padding: "0.5rem",
    borderRadius: "{content.border.radius}"
  },
  panel: {
    color: "{content.color}",
    shadow: "{overlay.popover.shadow}",
    padding: "{overlay.popover.padding}",
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}"
  },
  title: {
    gap: "0.5rem",
    fontWeight: "700"
  },
  header: {
    color: "{content.color}",
    padding: "0 0 0.75rem 0",
    background: "{content.background}",
    borderColor: "{content.border.color}"
  },
  dayView: {
    margin: "0.75rem 0 0 0"
  },
  weekDay: {
    color: "{content.color}",
    padding: "0.375rem",
    fontWeight: "700"
  },
  dropdown: {
    lg: {
      width: "3rem"
    },
    sm: {
      width: "2rem"
    },
    width: "2.5rem",
    focusRing: {
      color: "{form.field.focus.ring.color}",
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    borderColor: "{form.field.border.color}",
    borderRadius: "{form.field.border.radius}",
    hoverBorderColor: "{form.field.border.color}",
    activeBorderColor: "{form.field.border.color}",
    color: "light-dark({surface.600}, {surface.300})",
    background: "light-dark({surface.50}, {surface.800})",
    hoverColor: "light-dark({surface.700}, {surface.200})",
    activeColor: "light-dark({surface.800}, {surface.100})",
    hoverBackground: "light-dark({surface.100}, {surface.700})",
    activeBackground: "light-dark({surface.200}, {surface.600})"
  },
  yearView: {
    margin: "0.75rem 0 0 0"
  },
  buttonbar: {
    padding: "0.75rem 0 0 0",
    borderColor: "{content.border.color}"
  },
  inputIcon: {
    color: "{form.field.icon.color}"
  },
  monthView: {
    margin: "0.75rem 0 0 0"
  },
  selectYear: {
    color: "{content.color}",
    padding: "0.375rem 0.625rem",
    hoverColor: "{content.hover.color}",
    borderRadius: "{content.border.radius}",
    hoverBackground: "{content.hover.background}"
  },
  timePicker: {
    gap: "0.5rem",
    padding: "0.75rem 0 0 0",
    buttonGap: "0.25rem",
    borderColor: "{content.border.color}"
  },
  selectMonth: {
    color: "{content.color}",
    padding: "0.375rem 0.625rem",
    hoverColor: "{content.hover.color}",
    borderRadius: "{content.border.radius}",
    hoverBackground: "{content.hover.background}"
  },
  today: {
    color: "light-dark({surface.900}, {surface.0})",
    background: "light-dark({surface.200}, {surface.700})"
  }
};

// theme/ts/fileupload.ts
var fileupload_default = {
  file: {
    gap: "1rem",
    info: {
      gap: "0.5rem"
    },
    padding: "1rem",
    borderColor: "{content.border.color}"
  },
  root: {
    color: "{content.color}",
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    transitionDuration: "{transition.duration}"
  },
  basic: {
    gap: "0.5rem"
  },
  header: {
    gap: "0.5rem",
    padding: "1.125rem",
    borderColor: "{content.border.color}",
    borderWidth: "0 0 1px 0",
    borderRadius: "5px 5px 0 0",
    color: "{text.color}",
    background: "light-dark({surface.50}, {surface.800})"
  },
  content: {
    gap: "1rem",
    padding: "1.125rem",
    highlightBorderColor: "{primary.color}"
  },
  fileList: {
    gap: "0.5rem"
  },
  progressbar: {
    height: "0.25rem"
  }
};

// theme/ts/floatlabel.ts
var floatlabel_default = {
  in: {
    input: {
      paddingTop: "1.875rem",
      paddingBottom: "{form.field.padding.y}"
    },
    active: {
      top: "{form.field.padding.y}"
    }
  },
  on: {
    active: {
      padding: "0 0.125rem",
      background: "{form.field.background}"
    },
    borderRadius: "{border.radius.xs}"
  },
  over: {
    active: {
      top: "-1.375rem"
    }
  },
  root: {
    color: "{form.field.float.label.color}",
    active: {
      fontSize: "0.75rem",
      fontWeight: "400"
    },
    positionX: "{form.field.padding.x}",
    positionY: "{form.field.padding.y}",
    focusColor: "{form.field.float.label.focus.color}",
    fontWeight: "500",
    activeColor: "{form.field.float.label.active.color}",
    invalidColor: "{form.field.float.label.invalid.color}",
    transitionDuration: "0.2s"
  }
};

// theme/ts/inputchips.ts
var inputchips_default = {
  chip: {
    borderRadius: "{border.radius.sm}",
    color: "light-dark({surface.800}, {surface.0})",
    focusBackground: "light-dark({surface.200}, {surface.700})"
  },
  root: {
    color: "{form.field.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    focusRing: {
      color: "{form.field.focus.ring.color}",
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    background: "{form.field.background}",
    borderColor: "{form.field.border.color}",
    borderRadius: "{form.field.border.radius}",
    disabledColor: "{form.field.disabled.color}",
    filledBackground: "{form.field.filled.background}",
    focusBorderColor: "{form.field.focus.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    placeholderColor: "{form.field.placeholder.color}",
    disabledBackground: "{form.field.disabled.background}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    transitionDuration: "{form.field.transition.duration}",
    filledFocusBackground: "{form.field.filled.focus.background}"
  }
};

// theme/ts/inputgroup.ts
var inputgroup_default = {
  addon: {
    padding: "0.625rem 0.5rem",
    minWidth: "2.75rem",
    borderRadius: "{form.field.border.radius}",
    color: "{text.muted.color}",
    background: "light-dark({surface.50}, {surface.800})",
    borderColor: "{form.field.border.color}"
  }
};

// theme/ts/metergroup.ts
var metergroup_default = {
  root: {
    gap: "1rem",
    borderRadius: "{content.border.radius}"
  },
  label: {
    gap: "0.5rem"
  },
  meters: {
    size: "0.625rem",
    background: "{content.border.color}"
  },
  labelIcon: {
    size: "1rem"
  },
  labelList: {
    verticalGap: "0.5rem",
    horizontalGap: "1rem"
  },
  labelMarker: {
    size: "0.5rem"
  }
};

// theme/ts/tieredmenu.ts
var tieredmenu_default = {
  item: {
    gap: "{navigation.item.gap}",
    icon: {
      color: "{navigation.item.icon.color}",
      focusColor: "{navigation.item.icon.focus.color}",
      activeColor: "{navigation.item.icon.active.color}"
    },
    color: "{navigation.item.color}",
    padding: "{navigation.item.padding}",
    focusColor: "{navigation.item.focus.color}",
    activeColor: "{navigation.item.active.color}",
    borderRadius: "{navigation.item.border.radius}",
    focusBackground: "{navigation.item.focus.background}",
    activeBackground: "{navigation.item.active.background}"
  },
  list: {
    gap: "{navigation.list.gap}",
    padding: "{navigation.list.padding}"
  },
  root: {
    color: "{content.color}",
    shadow: "{overlay.navigation.shadow}",
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    transitionDuration: "{transition.duration}"
  },
  submenu: {
    mobileIndent: "1.25rem"
  },
  separator: {
    borderColor: "{content.border.color}"
  },
  submenuIcon: {
    size: "{navigation.submenu.icon.size}",
    color: "{navigation.submenu.icon.color}",
    focusColor: "{navigation.submenu.icon.focus.color}",
    activeColor: "{navigation.submenu.icon.active.color}"
  }
};

// theme/ts/treeselect.ts
var treeselect_default = {
  chip: {
    borderRadius: "{border.radius.sm}"
  },
  root: {
    lg: {
      fontSize: "{form.field.lg.font.size}",
      paddingX: "{form.field.lg.padding.x}",
      paddingY: "{form.field.lg.padding.y}"
    },
    sm: {
      fontSize: "{form.field.sm.font.size}",
      paddingX: "{form.field.sm.padding.x}",
      paddingY: "{form.field.sm.padding.y}"
    },
    color: "{form.field.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    focusRing: {
      color: "{form.field.focus.ring.color}",
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    background: "{form.field.background}",
    borderColor: "{form.field.border.color}",
    borderRadius: "{form.field.border.radius}",
    disabledColor: "{form.field.disabled.color}",
    filledBackground: "{form.field.filled.background}",
    focusBorderColor: "{form.field.focus.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    placeholderColor: "{form.field.placeholder.color}",
    disabledBackground: "{form.field.disabled.background}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    transitionDuration: "{form.field.transition.duration}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    filledHoverBackground: "{form.field.filled.hover.background}",
    invalidPlaceholderColor: "{form.field.invalid.placeholder.color}"
  },
  tree: {
    padding: "{list.padding}"
  },
  overlay: {
    color: "{overlay.select.color}",
    shadow: "{overlay.select.shadow}",
    background: "{overlay.select.background}",
    borderColor: "{overlay.select.border.color}",
    borderRadius: "{overlay.select.border.radius}"
  },
  dropdown: {
    color: "{form.field.icon.color}",
    width: "2.5rem"
  },
  clearIcon: {
    color: "{form.field.icon.color}"
  },
  emptyMessage: {
    padding: "{list.option.padding}"
  }
};

// theme/ts/colorpicker.ts
var colorpicker_default = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  panel: {
    shadow: "{overlay.popover.shadow}",
    borderRadius: "{overlay.popover.borderRadius}",
    background: "light-dark({surface.800}, {surface.900})",
    borderColor: "light-dark({surface.900}, {surface.700})"
  },
  preview: {
    width: "1.75rem",
    height: "1.75rem",
    focusRing: {
      color: "{form.field.focus.ring.color}",
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    borderRadius: "{form.field.border.radius}"
  },
  handle: {
    color: "{surface.0}"
  }
};

// theme/ts/contextmenu.ts
var contextmenu_default = {
  item: {
    gap: "{navigation.item.gap}",
    icon: {
      color: "{navigation.item.icon.color}",
      focusColor: "{navigation.item.icon.focus.color}",
      activeColor: "{navigation.item.icon.active.color}"
    },
    color: "{navigation.item.color}",
    padding: "{navigation.item.padding}",
    focusColor: "{navigation.item.focus.color}",
    activeColor: "{navigation.item.active.color}",
    borderRadius: "{navigation.item.border.radius}",
    focusBackground: "{navigation.item.focus.background}",
    activeBackground: "{navigation.item.active.background}"
  },
  list: {
    gap: "{navigation.list.gap}",
    padding: "{navigation.list.padding}"
  },
  root: {
    color: "{content.color}",
    shadow: "{overlay.navigation.shadow}",
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    transitionDuration: "{transition.duration}"
  },
  submenu: {
    mobileIndent: "1.25rem"
  },
  separator: {
    borderColor: "{content.border.color}"
  },
  submenuIcon: {
    size: "{navigation.submenu.icon.size}",
    color: "{navigation.submenu.icon.color}",
    focusColor: "{navigation.submenu.icon.focus.color}",
    activeColor: "{navigation.submenu.icon.active.color}"
  }
};

// theme/ts/inputnumber.ts
var inputnumber_default = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  button: {
    width: "2.5rem",
    borderRadius: "{form.field.border.radius}",
    verticalPadding: "{form.field.padding.y}",
    color: "light-dark({surface.600}, {surface.300})",
    background: "light-dark({surface.100}, {surface.800})",
    hoverColor: "light-dark({surface.700}, {surface.200})",
    activeColor: "light-dark({surface.800}, {surface.100})",
    borderColor: "{form.field.border.color}",
    hoverBackground: "light-dark({surface.200}, {surface.700})",
    activeBackground: "light-dark({surface.300}, {surface.500})",
    hoverBorderColor: "{form.field.border.color}",
    activeBorderColor: "{form.field.border.color}"
  }
};

// theme/ts/multiselect.ts
var multiselect_default = {
  chip: {
    borderRadius: "{border.radius.sm}"
  },
  list: {
    gap: "{list.gap}",
    header: {
      padding: "{list.header.padding}"
    },
    padding: "{list.padding}"
  },
  root: {
    lg: {
      fontSize: "{form.field.lg.font.size}",
      paddingX: "{form.field.lg.padding.x}",
      paddingY: "{form.field.lg.padding.y}"
    },
    sm: {
      fontSize: "{form.field.sm.font.size}",
      paddingX: "{form.field.sm.padding.x}",
      paddingY: "{form.field.sm.padding.y}"
    },
    color: "{form.field.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    focusRing: {
      color: "{form.field.focus.ring.color}",
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    background: "{form.field.background}",
    borderColor: "{form.field.border.color}",
    borderRadius: "{form.field.border.radius}",
    disabledColor: "{form.field.disabled.color}",
    filledBackground: "{form.field.filled.background}",
    focusBorderColor: "{form.field.focus.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    placeholderColor: "{form.field.placeholder.color}",
    disabledBackground: "{form.field.disabled.background}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    transitionDuration: "{form.field.transition.duration}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    filledHoverBackground: "{form.field.filled.hover.background}",
    invalidPlaceholderColor: "{form.field.invalid.placeholder.color}"
  },
  option: {
    gap: "0.5rem",
    color: "{list.option.color}",
    padding: "{list.option.padding}",
    focusColor: "{list.option.focus.color}",
    borderRadius: "{list.option.border.radius}",
    selectedColor: "{list.option.selected.color}",
    focusBackground: "{list.option.focus.background}",
    selectedBackground: "{list.option.selected.background}",
    selectedFocusColor: "{list.option.selected.focus.color}",
    selectedFocusBackground: "{list.option.selected.focus.background}"
  },
  overlay: {
    color: "{overlay.select.color}",
    shadow: "{overlay.select.shadow}",
    background: "{overlay.select.background}",
    borderColor: "{overlay.select.border.color}",
    borderRadius: "{overlay.select.border.radius}"
  },
  dropdown: {
    color: "{form.field.icon.color}",
    width: "2.5rem"
  },
  clearIcon: {
    color: "{form.field.icon.color}"
  },
  optionGroup: {
    color: "{list.option.group.color}",
    padding: "{list.option.group.padding}",
    background: "{list.option.group.background}",
    fontWeight: "{list.option.group.font.weight}"
  },
  emptyMessage: {
    padding: "{list.option.padding}"
  }
};

// theme/ts/progressbar.ts
var progressbar_default = {
  root: {
    height: "1.5rem",
    background: "{content.border.color}",
    borderRadius: "{content.border.radius}"
  },
  label: {
    color: "{primary.contrast.color}",
    fontSize: "0.875rem",
    fontWeight: "600"
  },
  value: {
    background: "{primary.color}"
  }
};

// theme/ts/radiobutton.ts
var radiobutton_default = {
  icon: {
    lg: {
      size: "1.25rem"
    },
    sm: {
      size: "0.75rem"
    },
    size: "0.75rem",
    checkedColor: "{primary.color}",
    disabledColor: "{form.field.disabled.color}",
    checkedHoverColor: "{primary.hover.color}"
  },
  root: {
    lg: {
      width: "1.75rem",
      height: "1.75rem"
    },
    sm: {
      width: "1.25rem",
      height: "1.25rem"
    },
    width: "1.25rem",
    height: "1.25rem",
    shadow: "{form.field.shadow}",
    focusRing: {
      color: "{form.field.focus.ring.color}",
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    background: "{form.field.background}",
    borderColor: "{form.field.border.color}",
    filledBackground: "{form.field.filled.background}",
    focusBorderColor: "{form.field.focus.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    checkedBackground: "{form.field.background}",
    checkedBorderColor: "{primary.color}",
    disabledBackground: "{form.field.disabled.background}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    transitionDuration: "{form.field.transition.duration}",
    checkedHoverBackground: "{form.field.background}",
    checkedFocusBorderColor: "{primary.color}",
    checkedHoverBorderColor: "{primary.hover.color}",
    checkedDisabledBorderColor: "{form.field.border.color}"
  }
};

// theme/ts/scrollpanel.ts
var scrollpanel_default = {
  bar: {
    size: "9px",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    borderRadius: "{border.radius.sm}",
    background: "light-dark({surface.200}, {surface.700})"
  },
  root: {
    transitionDuration: "{transition.duration}"
  }
};

// theme/ts/splitbutton.ts
var splitbutton_default = {
  root: {
    borderRadius: "{form.field.border.radius}",
    raisedShadow: "0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
    roundedBorderRadius: "2rem"
  }
};

// theme/ts/autocomplete.ts
var autocomplete_default = {
  chip: {
    borderRadius: "{border.radius.sm}",
    focusColor: "light-dark({surface.800}, {surface.0})",
    focusBackground: "light-dark({surface.200}, {surface.700})"
  },
  list: {
    gap: "{list.gap}",
    padding: "{list.padding}"
  },
  root: {
    color: "{form.field.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    focusRing: {
      color: "{form.field.focus.ring.color}",
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    background: "{form.field.background}",
    borderColor: "{form.field.border.color}",
    borderRadius: "{form.field.border.radius}",
    disabledColor: "{form.field.disabled.color}",
    filledBackground: "{form.field.filled.background}",
    focusBorderColor: "{form.field.focus.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    placeholderColor: "{form.field.placeholder.color}",
    disabledBackground: "{form.field.disabled.background}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    transitionDuration: "{form.field.transition.duration}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    filledHoverBackground: "{form.field.filled.hover.background}",
    invalidPlaceholderColor: "{form.field.invalid.placeholder.color}"
  },
  option: {
    color: "{list.option.color}",
    padding: "{list.option.padding}",
    focusColor: "{list.option.focus.color}",
    borderRadius: "{list.option.border.radius}",
    selectedColor: "{list.option.selected.color}",
    focusBackground: "{list.option.focus.background}",
    selectedBackground: "{list.option.selected.background}",
    selectedFocusColor: "{list.option.selected.focus.color}",
    selectedFocusBackground: "{list.option.selected.focus.background}"
  },
  overlay: {
    color: "{overlay.select.color}",
    shadow: "{overlay.select.shadow}",
    background: "{overlay.select.background}",
    borderColor: "{overlay.select.border.color}",
    borderRadius: "{overlay.select.border.radius}"
  },
  dropdown: {
    lg: {
      width: "3rem"
    },
    sm: {
      width: "2rem"
    },
    width: "2.5rem",
    focusRing: {
      color: "{form.field.focus.ring.color}",
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    borderColor: "{form.field.border.color}",
    borderRadius: "{form.field.border.radius}",
    hoverBorderColor: "{form.field.border.color}",
    activeBorderColor: "{form.field.border.color}",
    color: "light-dark({surface.600}, {surface.300})",
    background: "light-dark({surface.50}, {surface.800})",
    hoverColor: "light-dark({surface.700}, {surface.200})",
    activeColor: "light-dark({surface.800}, {surface.100})",
    hoverBackground: "light-dark({surface.100}, {surface.700})",
    activeBackground: "light-dark({surface.200}, {surface.600})"
  },
  optionGroup: {
    color: "{list.option.group.color}",
    padding: "{list.option.group.padding}",
    background: "{list.option.group.background}",
    fontWeight: "{list.option.group.font.weight}"
  },
  emptyMessage: {
    padding: "{list.option.padding}"
  }
};

// theme/ts/confirmpopup.ts
var confirmpopup_default = {
  icon: {
    size: "1.5rem",
    color: "{overlay.popover.color}"
  },
  root: {
    color: "{overlay.popover.color}",
    gutter: "10px",
    shadow: "{overlay.popover.shadow}",
    background: "{overlay.popover.background}",
    arrowOffset: "1.25rem",
    borderColor: "{overlay.popover.border.color}",
    borderRadius: "{overlay.popover.border.radius}"
  },
  footer: {
    gap: "0.5rem",
    padding: "0 {overlay.popover.padding} {overlay.popover.padding} {overlay.popover.padding}"
  },
  content: {
    gap: "1rem",
    padding: "{overlay.popover.padding}"
  }
};

// theme/ts/imagecompare.ts
var imagecompare_default = {
  handle: {
    size: "15px",
    focusRing: {
      color: "rgba(255,255,255,0.3)",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    hoverSize: "30px",
    background: "rgba(255,255,255,0.3)",
    borderColor: "rgba(255,255,255,0.3)",
    borderWidth: "3px",
    borderRadius: "50%",
    hoverBackground: "rgba(255,255,255,0.3)",
    hoverBorderColor: "rgba(255,255,255,0.3)",
    transitionDuration: "{transition.duration}"
  }
};

// theme/ts/overlaybadge.ts
var overlaybadge_default = {
  root: {
    outline: {
      color: "{content.background}",
      width: "2px"
    }
  }
};

// theme/ts/selectbutton.ts
var selectbutton_default = {
  root: {
    borderRadius: "{form.field.border.radius}",
    invalidBorderColor: "{form.field.invalid.border.color}"
  }
};

// theme/ts/togglebutton.ts
var togglebutton_default = {
  icon: {
    color: "{text.muted.color}",
    hoverColor: "{text.muted.color}",
    checkedColor: "{highlight.color}",
    disabledColor: "{form.field.disabled.color}"
  },
  root: {
    lg: {
      padding: "0.75rem 1.25rem",
      fontSize: "{form.field.lg.font.size}"
    },
    sm: {
      padding: "0.5rem 0.75rem",
      fontSize: "{form.field.sm.font.size}"
    },
    gap: "0.5rem",
    color: "{form.field.color}",
    padding: "0.625rem 1rem",
    focusRing: {
      color: "{form.field.focus.ring.color}",
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    background: "{form.field.background}",
    fontWeight: "500",
    hoverColor: "{form.field.color}",
    borderColor: "{form.field.border.color}",
    borderRadius: "{content.border.radius}",
    checkedColor: "{highlight.color}",
    disabledColor: "{form.field.disabled.color}",
    checkedBackground: "{highlight.background}",
    checkedBorderColor: "{form.field.border.color}",
    disabledBackground: "{form.field.disabled.background}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    transitionDuration: "{form.field.transition.duration}",
    disabledBorderColor: "{form.field.disabled.background}",
    hoverBackground: "light-dark({surface.100}, {surface.800})"
  },
  content: {
    lg: {
      padding: "0"
    },
    sm: {
      padding: "0"
    },
    padding: "0",
    borderRadius: "0",
    checkedShadow: "none",
    checkedBackground: "transparent"
  }
};

// theme/ts/toggleswitch.ts
var toggleswitch_default = {
  root: {
    gap: "0.25rem",
    width: "3rem",
    height: "1.75rem",
    shadow: "{form.field.shadow}",
    focusRing: {
      color: "{form.field.focus.ring.color}",
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    borderColor: "transparent",
    borderWidth: "1px",
    borderRadius: "30px",
    slideDuration: "0.2s",
    hoverBorderColor: "transparent",
    checkedBorderColor: "transparent",
    invalidBorderColor: "{form.field.invalid.border.color}",
    transitionDuration: "{form.field.transition.duration}",
    checkedHoverBorderColor: "transparent",
    background: "light-dark({surface.300}, {surface.700})",
    hoverBackground: "light-dark({surface.400}, {surface.600})",
    checkedBackground: "{primary.color}",
    disabledBackground: "light-dark({form.field.disabled.background}, {surface.600})",
    checkedHoverBackground: "{primary.hover.color}"
  },
  handle: {
    size: "1.25rem",
    borderRadius: "50%",
    color: "light-dark({text.muted.color}, {surface.900})",
    background: "light-dark({surface.0}, {surface.400})",
    hoverColor: "light-dark({text.color}, {surface.800})",
    checkedColor: "{primary.color}",
    hoverBackground: "light-dark({surface.0}, {surface.300})",
    checkedBackground: "light-dark({surface.0}, {surface.900})",
    checkedHoverColor: "{primary.hover.color}",
    disabledBackground: "light-dark({form.field.disabled.color}, {surface.900})",
    checkedHoverBackground: "light-dark({surface.0}, {surface.900})"
  }
};

// theme/ts/cascadeselect.ts
var cascadeselect_default = {
  list: {
    gap: "{list.gap}",
    padding: "{list.padding}",
    mobileIndent: "1.25rem"
  },
  root: {
    lg: {
      fontSize: "{form.field.lg.font.size}",
      paddingX: "{form.field.lg.padding.x}",
      paddingY: "{form.field.lg.padding.y}"
    },
    sm: {
      fontSize: "{form.field.sm.font.size}",
      paddingX: "{form.field.sm.padding.x}",
      paddingY: "{form.field.sm.padding.y}"
    },
    color: "{form.field.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    focusRing: {
      color: "{form.field.focus.ring.color}",
      style: "{form.field.focus.ring.style}",
      width: "{form.field.focus.ring.width}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    background: "{form.field.background}",
    borderColor: "{form.field.border.color}",
    borderRadius: "{form.field.border.radius}",
    disabledColor: "{form.field.disabled.color}",
    filledBackground: "{form.field.filled.background}",
    focusBorderColor: "{form.field.focus.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    placeholderColor: "{form.field.placeholder.color}",
    disabledBackground: "{form.field.disabled.background}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    transitionDuration: "{form.field.transition.duration}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    filledHoverBackground: "{form.field.filled.hover.background}",
    invalidPlaceholderColor: "{form.field.invalid.placeholder.color}"
  },
  option: {
    icon: {
      size: "0.875rem",
      color: "{list.option.icon.color}",
      focusColor: "{list.option.icon.focus.color}"
    },
    color: "{list.option.color}",
    padding: "{list.option.padding}",
    focusColor: "{list.option.focus.color}",
    borderRadius: "{list.option.border.radius}",
    selectedColor: "{list.option.selected.color}",
    focusBackground: "{list.option.focus.background}",
    selectedBackground: "{list.option.selected.background}",
    selectedFocusColor: "{list.option.selected.focus.color}",
    selectedFocusBackground: "{list.option.selected.focus.background}"
  },
  overlay: {
    color: "{overlay.select.color}",
    shadow: "{overlay.select.shadow}",
    background: "{overlay.select.background}",
    borderColor: "{overlay.select.border.color}",
    borderRadius: "{overlay.select.border.radius}"
  },
  dropdown: {
    color: "{form.field.icon.color}",
    width: "2.5rem"
  },
  clearIcon: {
    color: "{form.field.icon.color}"
  }
};

// theme/ts/confirmdialog.ts
var confirmdialog_default = {
  icon: {
    size: "2rem",
    color: "{overlay.modal.color}"
  },
  content: {
    gap: "1rem"
  }
};

// theme/ts/inlinemessage.ts
var inlinemessage_default = {
  icon: {
    size: "1.125rem"
  },
  root: {
    gap: "0.5rem",
    padding: "{form.field.padding.y} {form.field.padding.x}",
    borderRadius: "{content.border.radius}"
  },
  text: {
    fontWeight: "500"
  },
  info: {
    color: "light-dark({blue.600}, {blue.500})",
    shadow: "none",
    background: "light-dark(color-mix(in srgb, {blue.50}, transparent 5%), color-mix(in srgb, {blue.500}, transparent 84%))",
    borderColor: "light-dark(color-mix(in srgb, {blue.50}, transparent 5%), color-mix(in srgb, {blue.500}, transparent 84%))"
  },
  warn: {
    color: "light-dark({yellow.600}, {yellow.500})",
    shadow: "none",
    background: "light-dark(color-mix(in srgb,{yellow.50}, transparent 5%), color-mix(in srgb, {yellow.500}, transparent 84%))",
    borderColor: "light-dark(color-mix(in srgb,{yellow.50}, transparent 5%), color-mix(in srgb, {yellow.500}, transparent 84%))"
  },
  error: {
    color: "light-dark({red.600}, {red.500})",
    shadow: "none",
    background: "light-dark(color-mix(in srgb, {red.50}, transparent 5%), color-mix(in srgb, {red.500}, transparent 84%))",
    borderColor: "light-dark(color-mix(in srgb, {red.50}, transparent 5%), color-mix(in srgb, {red.500}, transparent 84%))"
  },
  success: {
    color: "light-dark({green.600}, {green.500})",
    shadow: "none",
    background: "light-dark(color-mix(in srgb, {green.50}, transparent 5%), color-mix(in srgb, {green.500}, transparent 84%))",
    borderColor: "light-dark(color-mix(in srgb, {green.50}, transparent 5%), color-mix(in srgb, {green.500}, transparent 84%))"
  },
  contrast: {
    color: "light-dark({surface.50}, {surface.950})",
    shadow: "none",
    background: "light-dark({surface.900}, {surface.0})",
    borderColor: "light-dark({surface.900}, {surface.0})"
  },
  secondary: {
    color: "light-dark({surface.600}, {surface.300})",
    shadow: "none",
    background: "light-dark({surface.100}, {surface.800})",
    borderColor: "light-dark({surface.100}, {surface.800})"
  }
};

// theme/ts/progressspinner.ts
var progressspinner_default = {
  root: {
    colorOne: "{primary.color}",
    colorTwo: "{primary.color}",
    colorFour: "{primary.color}",
    colorThree: "{primary.color}"
  }
};

// theme/ts/virtualscroller.ts
var virtualscroller_default = {
  loader: {
    icon: {
      size: "2rem"
    },
    mask: {
      color: "{text.muted.color}",
      background: "{content.background}"
    }
  }
};

// theme/ts/organizationchart.ts
var organizationchart_default = {
  node: {
    color: "{content.color}",
    padding: "1rem 1.25rem",
    background: "{content.background}",
    hoverColor: "{content.hover.color}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    selectedColor: "{highlight.color}",
    hoverBackground: "{content.hover.background}",
    toggleablePadding: "1rem 1.25rem 1.5rem 1.25rem",
    selectedBackground: "{highlight.background}"
  },
  root: {
    gutter: "0.75rem",
    transitionDuration: "{transition.duration}"
  },
  connector: {
    color: "{content.border.color}",
    height: "24px",
    borderRadius: "{content.border.radius}"
  },
  nodeToggleButton: {
    size: "1.75rem",
    color: "{text.muted.color}",
    focusRing: {
      color: "{focus.ring.color}",
      style: "{focus.ring.style}",
      width: "{focus.ring.width}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    background: "{content.background}",
    hoverColor: "{text.color}",
    borderColor: "{content.border.color}",
    borderRadius: "50%",
    hoverBackground: "{content.hover.background}"
  }
};

// theme/ts/extend.ts
var extend_default = {};

// theme/ts/index.ts
var ts_default = {
  ...base_default,
  components: {
    tag: tag_default,
    card: card_default,
    chip: chip_default,
    dock: dock_default,
    knob: knob_default,
    menu: menu_default,
    tabs: tabs_default,
    tree: tree_default,
    badge: badge_default,
    image: image_default,
    panel: panel_default,
    steps: steps_default,
    toast: toast_default,
    avatar: avatar_default,
    button: button_default,
    dialog: dialog_default,
    drawer: drawer_default,
    editor: editor_default,
    rating: rating_default,
    ripple: ripple_default,
    select: select_default,
    slider: slider_default,
    blockui: blockui_default,
    divider: divider_default,
    inplace: inplace_default,
    listbox: listbox_default,
    menubar: menubar_default,
    message: message_default,
    popover: popover_default,
    stepper: stepper_default,
    tabmenu: tabmenu_default,
    tabview: tabview_default,
    toolbar: toolbar_default,
    tooltip: tooltip_default,
    carousel: carousel_default,
    checkbox: checkbox_default,
    dataview: dataview_default,
    fieldset: fieldset_default,
    galleria: galleria_default,
    inputotp: inputotp_default,
    megamenu: megamenu_default,
    password: password_default,
    picklist: picklist_default,
    skeleton: skeleton_default,
    splitter: splitter_default,
    terminal: terminal_default,
    textarea: textarea_default,
    timeline: timeline_default,
    accordion: accordion_default,
    datatable: datatable_default,
    iconfield: iconfield_default,
    iftalabel: iftalabel_default,
    inputtext: inputtext_default,
    orderlist: orderlist_default,
    paginator: paginator_default,
    panelmenu: panelmenu_default,
    speeddial: speeddial_default,
    treetable: treetable_default,
    breadcrumb: breadcrumb_default,
    datepicker: datepicker_default,
    fileupload: fileupload_default,
    floatlabel: floatlabel_default,
    inputchips: inputchips_default,
    inputgroup: inputgroup_default,
    metergroup: metergroup_default,
    tieredmenu: tieredmenu_default,
    treeselect: treeselect_default,
    colorpicker: colorpicker_default,
    contextmenu: contextmenu_default,
    inputnumber: inputnumber_default,
    multiselect: multiselect_default,
    progressbar: progressbar_default,
    radiobutton: radiobutton_default,
    scrollpanel: scrollpanel_default,
    splitbutton: splitbutton_default,
    autocomplete: autocomplete_default,
    confirmpopup: confirmpopup_default,
    imagecompare: imagecompare_default,
    overlaybadge: overlaybadge_default,
    selectbutton: selectbutton_default,
    togglebutton: togglebutton_default,
    toggleswitch: toggleswitch_default,
    cascadeselect: cascadeselect_default,
    confirmdialog: confirmdialog_default,
    inlinemessage: inlinemessage_default,
    progressspinner: progressspinner_default,
    virtualscroller: virtualscroller_default,
    organizationchart: organizationchart_default
  },
  extend: extend_default
};
export {
  ts_default as default
};
//# sourceMappingURL=index.mjs.map